const stores_mapping = [
  {
    "Branch Code": "79",

    "Old Store Names": "The Fort 26th St-4th Ave",

    store_name: "The Fort-Marajo Tower",

    main_email: "pbc_fort@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "268",

    "Old Store Names": "The Fort 32nd St-5th Ave",

    store_name: "The Fort-F1 Center",

    main_email: "#RBG-Division1-TheFort-F1@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "125",

    "Old Store Names": "Burgos Circle",

    store_name: "The Fort-Burgos Circle",

    main_email: "#RBG-Division1-TheFort-BurgosCircle@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "203",

    "Old Store Names": "The Fort - Beaufort",

    store_name: "The Fort-Beaufort",

    main_email: "#RBG-Division1-TheFort-Beaufort@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "605",

    "Old Store Names": "The Fort-PSE Tower",

    store_name: "The Fort-PSE Tower",

    main_email: "#RBG-Division1-TheFort-PSETower@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "261",

    "Old Store Names": "The Fort 26th St-11th Ave",

    store_name: "The Fort-South of Market",

    main_email: "#RBG-Division1-TheFort26thSt-11thAve@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "554",

    "Old Store Names": "The Fort 28th St-9th Ave",

    store_name: "The Fort-Active Fun",

    main_email: "#RBG-Division1-TheFort-ActiveFun@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "595",

    "Old Store Names": "The Fort 11th Ave.-30th St.",

    store_name: "The Fort-BGC Corporate Center",

    main_email:
      "#RBG-Division1-TheFort-11thAvenue30thStreet@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "602",

    "Old Store Names": "",

    store_name: "The Fort Seven Neo",

    main_email: "#RBG-Division1-TheFort-SevenNeo@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "609",

    "Old Store Names": "The Fort - Brilliance Center",

    store_name: "The Fort - Brilliance Center",

    main_email: "#RBG-Division1-TheFort-BrillianceCenter@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "568",

    "Old Store Names": "P.Ocampo Avenue",

    store_name: "P.Ocampo Avenue",

    main_email: "mgatienza@eastwestbanker.com",

    copy_email_address: "jdalonzo@eastwestbanker.com",

    "": "",
  },

  {
    "Branch Code": "147",

    "Old Store Names": "Metropolitan Avenue",

    store_name: "Metropolitan Avenue",

    main_email: "mfzulaybar@eastwestbanker.com",

    copy_email_address: "mmbacho@eastwestbanker.com",

    "": "",
  },

  {
    "Branch Code": "160",

    "Old Store Names": "Pasong Tamo - Bagtikan",

    store_name: "Chino Roces-Bagtikan",

    main_email: "egcarandang@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "24",

    "Old Store Names": "Pasong Tamo",

    store_name: "Pasong Tamo Extension",

    main_email: "pbc_pasongtamo@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "168",

    "Old Store Names": "Ayala Ave. - SGV1",

    store_name: "Ayala Ave-SGV",

    main_email: "#RBG-Division2-AyalaAve.-SGV@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "257",

    "Old Store Names": "San Lorenzo Village - A. Arnaiz Avenue ",

    store_name: "San Lorenzo-A. Arnaiz",

    main_email: "#RBG-Division2-SanLorenzo-A.Arnaiz@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "508",

    "Old Store Names": "Perea",

    store_name: "Perea",

    main_email: "#RBG-Division2-Perea@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "87",

    "Old Store Names": "Ayala - Paseo",

    store_name: "Paseo-Philam Tower",

    main_email: "PASEOPHILAMTOWER@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "75",

    "Old Store Names": "Paseo de Roxas",

    store_name: "Paseo de Roxas-Legaspi",

    main_email: "pbc_paseoderoxas@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "189",

    "Old Store Names": "Rada",

    store_name: "Rada",

    main_email: "#RBG-Division2-Rada@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "197",

    "Old Store Names": "Benavidez",

    store_name: "Benavidez",

    main_email: "#RBG-Division2-Benavidez@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "201",

    "Old Store Names": "Amorsolo - Queensway",

    store_name: "Amorsolo-Queensway",

    main_email: "#RBG-Division2-Amorsolo-Queensway@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "213",

    "Old Store Names": "Ayala Avenue - Rufino Building ",

    store_name: "Ayala Ave-Rufino",

    main_email: "#RBG-Division2-AyalaAve-Rufino@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "527",

    "Old Store Names": "Chino Roces - La Fuerza",

    store_name: "Chino Roces-La Fuerza",

    main_email: "#RBG-Division2-ChinoRoces-LaFuerza@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "575",

    "Old Store Names": "Legaspi-Aguirre",

    store_name: "Legaspi-Aguirre",

    main_email: "#RBG-Division2-Legaspi-Aguirre@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "1",

    "Old Store Names": "Gil Puyat",

    store_name: "Gil Puyat-Metro House",

    main_email: "#RBG-Division3-GilPuyat@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "47",

    "Old Store Names": "Valero",

    store_name: "Valero",

    main_email: "pbc_valero@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "185",

    "Old Store Names": "Makati Ave. - Pacific Star",

    store_name: "Gil Puyat-Pacific Star",

    main_email: "#RBG-Division3-MakatiAve.-PacificStar@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "202",

    "Old Store Names": "Makati Ave.",

    store_name: "Makati Ave.-Juno",

    main_email: "#RBG-Division3-MakatiAvenue@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "208",

    "Old Store Names": "J.P. Rizal",

    store_name: "J.P. Rizal",

    main_email: "#RBG-Division3-JPRizal@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "237",

    "Old Store Names": "HV Dela Costa - Classica",

    store_name: "H.V. Dela Costa",

    main_email: "#RBG-Division3-H.V.DelaCosta@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "521",

    "Old Store Names": "Jupiter - Paseo de Roxas",

    store_name: "Jupiter-Paseo de Roxas",

    main_email: "#RBG-Division3-Jupiter-PaseodeRoxas@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "524",

    "Old Store Names": "Tordesillas",

    store_name: "Tordesillas",

    main_email: "#RBG-Division3-Tordesillas@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "528",

    "Old Store Names": "Gil Puyat - Salcedo Village",

    store_name: "Gil Puyat-Salcedo Vill.",

    main_email: "#RBG-Division3-GilPuyat-SalcedoVill@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "532",

    "Old Store Names": "Leviste",

    store_name: "Leviste",

    main_email: "#RBG-Division3-Leviste@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "9",

    "Old Store Names": "Ayala Avenue - Herrera",

    store_name: "Ayala Ave.-Herrera",

    main_email: "#RBG-Division4-AyalaAvenue-Herrera@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "48",

    "Old Store Names": "Salcedo",

    store_name: "Salcedo",

    main_email: "pbc_salcedo@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "96",

    "Old Store Names": "Dela Rosa, P. Tamo",

    store_name: "Chino Roces-Dela Rosa",

    main_email: "pbc_delarosa@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "103",

    "Old Store Names": "Legaspi",

    store_name: "Legaspi-Rufino",

    main_email: "pbc_legaspi@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "104",

    "Old Store Names": "Amorsolo",

    store_name: "Ayala Ave. - Makati Sky Plaza",

    main_email: "#RBG-Division4-AyalaAve-MakatiSkyPlaza@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "118",

    "Old Store Names": "Evangelista",

    store_name: "Evangelista",

    main_email: "pbc_evangelista@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "132",

    "Old Store Names": "Magallanes Village",

    store_name: "Paseo de Magallanes",

    main_email: "#RBG-Division4-PaseodeMagallanes@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "140",

    "Old Store Names": "Gil Puyat-F.B. Harrison",

    store_name: "Gil Puyat-F.B. Harrison",

    main_email: "#RBG-Division4-GilPuyat-F.B.Harrison@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "180",

    "Old Store Names": "Pasay - D. Macapagal Blvd.",

    store_name: "Pasay-D. Macapagal Blvd",

    main_email: "#RBG-Division4-Pasay-D.MacapagalBlvd@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "212",

    "Old Store Names": "Pasay - Libertad",

    store_name: "Pasay-Libertad",

    main_email: "#RBG-Division4-Pasay-Libertad@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "238",

    "Old Store Names": "Legaspi - Dela Rosa",

    store_name: "Legaspi-Dela Rosa",

    main_email: "#RBG-Division4-Legaspi-DelaRosa@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "275",

    "Old Store Names": "Gil Puyat - Dian",

    store_name: "Gil Puyat-Dian",

    main_email: "#RBG-Division4-GilPuyat-Dian@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "555",

    "Old Store Names": "Pasay-Oceanaire",

    store_name: "Pasay-Oceanaire",

    main_email: "#RBG-Division4-Pasay-Oceanaire@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "607",

    "Old Store Names": "Gil Puyat - Washington",

    store_name: "Gil Puyat - Washington",

    main_email: "#RBG-Division4-GilPuyat-Washington@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "23",

    "Old Store Names": "Sto. Cristo  ",

    store_name: "Sto. Cristo  ",

    main_email: "pbc_stocristo@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "54",

    "Old Store Names": "T. Alonzo",

    store_name: "T. Alonzo",

    main_email: "pbc_talonzo@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "74",

    "Old Store Names": "Binondo",

    store_name: "Binondo",

    main_email: "pbc_binondo@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "86",

    "Old Store Names": "Divisoria",

    store_name: "Divisoria",

    main_email: "pbc_divisoria@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "101",

    "Old Store Names": "Soler",

    store_name: "Soler",

    main_email: "pbc_soler@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "130",

    "Old Store Names": "168 Mall  ",

    store_name: "168 Mall  ",

    main_email: "#RBG-Division5-168Mall@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "154",

    "Old Store Names": "City Place Square",

    store_name: "City Place Square",

    main_email: "#RBG-Division5-CityplaceSquare@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "184",

    "Old Store Names": "Masangkay",

    store_name: "Masangkay",

    main_email: "#RBG-Division5-Masangkay@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "194",

    "Old Store Names": "Tomas Mapua - Lope de Vega",

    store_name: "Tomas Mapua-Lope de Vega",

    main_email: "#RBG-Division5-TomasMapua?LopedeVega@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "200",

    "Old Store Names": "999 Shopping Mall",

    store_name: "999 Shopping Mall",

    main_email: "#RBG-Division5-999ShoppingMall@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "241",

    "Old Store Names": "Elcano",

    store_name: "Elcano",

    main_email: "#RBG-Division5-ElCano@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "293",

    "Old Store Names": "Ongpin",

    store_name: "Ongpin",

    main_email: "#RBG-Division5-Ongpin@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "294",

    "Old Store Names": "Ylaya – Padre Rada",

    store_name: "Ylaya-Padre Rada",

    main_email: "#RBG-Division5-Ylaya-PadreRada@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "531",

    "Old Store Names": "Juan Luna - Binondo",

    store_name: "Juan Luna-Binondo",

    main_email: "#RBG-Division5-JuanLuna-Binondo@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "279",

    "Old Store Names": "Juan Luna- Pritil",

    store_name: "Juan Luna-Pritil",

    main_email: "#RBG-Division5-JuanLuna-Pritil@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "22",

    "Old Store Names": "Padre Faura",

    store_name: "Padre Faura",

    main_email: "pbc_padrefaura@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "69",

    "Old Store Names": "Intramuros  ",

    store_name: "Intramuros  ",

    main_email: "pbc_intramuros@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "93",

    "Old Store Names": "UN Avenue  ",

    store_name: "UN Avenue  ",

    main_email: "pbc_unavenue@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "100",

    "Old Store Names": "Paco  ",

    store_name: "Paco  ",

    main_email: "pbc_paco@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "114",

    "Old Store Names": "Roxas Boulevard  ",

    store_name: "Roxas Boulevard  ",

    main_email: "pbc_roxasblvd@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "141",

    "Old Store Names": "Taft-Nakpil",

    store_name: "Taft-Nakpil",

    main_email: "#RBG-Division6-Taft-Nakpil@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "193",

    "Old Store Names": "Taft Avenue",

    store_name: "Taft Avenue",

    main_email: "#RBG-Division6-TaftAvenue@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "195",

    "Old Store Names": "T.M. Kalaw",

    store_name: "T.M. Kalaw",

    main_email: "#RBG-Division6-T.M.Kalaw@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "533",

    "Old Store Names": "Paz M. Guazon",

    store_name: "Paz M. Guazon",

    main_email: "#RBG-Division6-PazM.Guazon@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "534",

    "Old Store Names": "Sampaloc-J. Figueras",

    store_name: "Sampaloc-J. Figueras",

    main_email: "#RBG-Division6-Sampaloc-J.Figueras@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "559",

    "Old Store Names": "Pedro Gil",

    store_name: "Pedro Gil",

    main_email: "#RBG-Division6-PedroGil@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "567",

    "Old Store Names": "A.Mabini-R.Salas",

    store_name: "A.Mabini-R.Salas",

    main_email: "#RBG-Division6-A.Mabini-R.Salas@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "97",

    "Old Store Names": "Baclaran  ",

    store_name: "Baclaran  ",

    main_email: "#RBG-Division6-Baclaran@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "199",

    "Old Store Names": "Quiapo",

    store_name: "Quiapo",

    main_email: "#RBG-Division6-Quiapo@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "28",

    "Old Store Names": "Escolta  ",

    store_name: "Escolta  ",

    main_email: "#RBG-Division6-Escolta@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "249",

    "Old Store Names": "Loyola Heights - Katipunan",

    store_name: "Loyola Heights-Katipunan",

    main_email: "#RBG-Division7-LoyolaHeights-Katipunan@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "242",

    "Old Store Names": "Fairview",

    store_name: "Fairview",

    main_email: "#RBG-Division7-Fairview@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "574",

    "Old Store Names": "Kalayaan-Matalino",

    store_name: "Kalayaan-Matalino",

    main_email: "#RBG-Division7-Kalayaan-Matalino@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "153",

    "Old Store Names": "Don Antonio",

    store_name: "Don Antonio Heights",

    main_email: "#RBG-Division7-DonAntonio@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "21",

    "Old Store Names": "Tandang Sora",

    store_name: "Tandang Sora",

    main_email: "#RBG-Division7-TandangSora@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "564",

    "Old Store Names": "Xavierville",

    store_name: "Xavierville",

    main_email: "#RBG-Division7-Xavierville@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "196",

    "Old Store Names": "UP Village ",

    store_name: "UP Village",

    main_email: "#RBG-Division7-UPVillage@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "231",

    "Old Store Names": "Commonwealth",

    store_name: "Commonwealth",

    main_email: "#RBG-Division7-Commonwealth@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "17",

    "Old Store Names": "Regalado",

    store_name: "Regalado",

    main_email: "#RBG-Division7-Regalado@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "520",

    "Old Store Names": "Shorthorn",

    store_name: "Project 8-Shorthorn",

    main_email: "#RBG-Division7-Project8-Shorthorn@eastwestbanker.com",

    copy_email_address: "",

    "": "l",
  },

  {
    "Branch Code": "13",

    "Old Store Names": "Congressional",

    store_name: "Congressional Ave.",

    main_email: "#RBG-Division7-Congressional@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "280",

    "Old Store Names": "Visayas Avenue",

    store_name: "Visayas Avenue",

    main_email: "#RBG-Division7-VisayasAvenue2@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "248",

    "Old Store Names": "Lagro",

    store_name: "Lagro",

    main_email: "#RBG-Division7-Lagro@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "110",

    "Old Store Names": "Novaliches",

    store_name: "Novaliches-Gulod",

    main_email: "#RBG-Division7-Novaliches@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "155",

    "Old Store Names": "Baesa Town Center",

    store_name: "Baesa Town Center",

    main_email: "#RBG-Division7-BaesaTownCenter@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "266",

    "Old Store Names": "Novaliches - Talipapa",

    store_name: "Novaliches-Talipapa",

    main_email: "#RBG-Division7-Novaliches-Talipapa@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "198",

    "Old Store Names": "Araneta Avenue",

    store_name: "G. Araneta Ave.",

    main_email: "#RBG-Division8-G.AranetaAvenue@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "156",

    "Old Store Names": "Banawe - Scout Alcaraz",

    store_name: "Banawe-Sct. Alcaraz",

    main_email: "#RBG-Division8-Banawe-Sct.Alcaraz@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "535",

    "Old Store Names": "Del Monte - D. Tuazon",

    store_name: "Del Monte-D. Tuazon",

    main_email: "#RBG-Division8-DelMonte-D.Tuazon@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "183",

    "Old Store Names": "Masambong",

    store_name: "Masambong",

    main_email: "#RBG-Division8-Masambong@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "29",

    "Old Store Names": "Banawe",

    store_name: "Quezon Ave.-Banawe",

    main_email: "#RBG-Division8-Banawe@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "295",

    "Old Store Names": "Banawe – Kaliraya",

    store_name: "Banawe-Kaliraya",

    main_email: "#RBG-Division8-Banawe-Kaliraya@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "98",

    "Old Store Names": "A. Bonifacio - Balintawak",

    store_name: "Balintawak-A. Bonifacio",

    main_email: "#RBG-Division8-A.Bonifacio-Balintawak@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "205",

    "Old Store Names": "North EDSA",

    store_name: "North EDSA",

    main_email: "#RBG-Division8-NorthEDSA@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "72",

    "Old Store Names": "Del Monte",

    store_name: "Del Monte",

    main_email: "#RBG-Division8-DelMonte@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "151",

    "Old Store Names": "Mayon",

    store_name: "Mayon",

    main_email: "#RBG-Division8-Mayon@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "560",

    "Old Store Names": "Mayon-Dapitan",

    store_name: "Mayon-Dapitan",

    main_email: "#RBG-Division8-Mayon-Dapitan@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "190",

    "Old Store Names": "Roosevelt - Sto. Niño",

    store_name: "Roosevelt-Sto. Niño",

    main_email: "#RBG-Division8-Roosevelt-Sto.Nino@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "563",

    "Old Store Names": "E.Rod-Welcome Rotonda",

    store_name: "E.Rod-Welcome Rotonda",

    main_email: "#RBG-Division8-E.Rod.-WelcomeRotonda@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "164",

    "Old Store Names": "Edsa Howmart",

    store_name: "Edsa Howmart",

    main_email: "#RBG-Division8-EDSA-Howmart@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "177",

    "Old Store Names": "EDSA - Muñoz",

    store_name: "EDSA-Muñoz",

    main_email: "#RBG-Division8-EDSA-Munoz@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "276",

    "Old Store Names": "A. Bonifacio - Balingasa",

    store_name: "A. Bonifacio-Balingasa",

    main_email: "#RBG-Division8-A.Bonifacio-Balingasa@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "6",

    "Old Store Names": "Roosevelt",

    store_name: "Roosevelt-Frisco",

    main_email: "#RBG-Division8-Roosevelt@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "162",

    "Old Store Names": "Banawe - N. Roxas",

    store_name: "Banawe-N. Roxas",

    main_email: "#RBG-Division8-Banawe-N.Roxas@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "5",

    "Old Store Names": "EDSA - Kalookan",

    store_name: "EDSA-Kalookan",

    main_email: "#RBG-Division9-Edsa-Kalookan@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "45",

    "Old Store Names": "Valenzuela",

    store_name: "Valenzuela-Marulas",

    main_email: "#RBG-Division9-Valenzuela-Marulas@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "73",

    "Old Store Names": "Grace Park",

    store_name: "Grace Park-8th Ave.",

    main_email: "#RBG-Division9-GracePark@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "82",

    "Old Store Names": "Paso De Blas",

    store_name: "Paso De Blas",

    main_email: "#RBG-Division9-PasodeBlas@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "84",

    "Old Store Names": "Gov. Pascual, Malabon",

    store_name: "Malabon-Gov. Pascual",

    main_email: "#RBG-Division9-Gov.Pascual@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "116",

    "Old Store Names": "Potrero",

    store_name: "Malabon-Potrero",

    main_email: "#RBG-Division9-Potrero@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "121",

    "Old Store Names": "Northbay, Navotas",

    store_name: "Navotas-North Bay",

    main_email: "#RBG-Division9-NorthbayNavotas@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "144",

    "Old Store Names": "Caloocan - A. Mabini",

    store_name: "Caloocan-A. Mabini",

    main_email: "#RBG-Division9-Caloocan-A.Mabini@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "209",

    "Old Store Names": "Grace Park - 7th Avenue",

    store_name: "Grace Park-7th Ave.",

    main_email: "#RBG-Division9-Gracepark-7thAvenue@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "250",

    "Old Store Names": "Malabon - Rizal Avenue",

    store_name: "Malabon-Rizal Avenue",

    main_email: "#RBG-Division9-Malabon-RizalAvenue@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "286",

    "Old Store Names": "Grace Park - 11th Avenue",

    store_name: "Grace Park-11th Ave.",

    main_email: "#RBG-Division9-Gracepark-11thAvenue@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "289",

    "Old Store Names": "Valenzuela – Dalandanan",

    store_name: "Valenzuela-Dalandanan",

    main_email: "#RBG-Division9-Valenzuela-Dalandanan@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "292",

    "Old Store Names": "Navotas - M. Naval",

    store_name: "Navotas-M. Naval",

    main_email: "#RBG-Division9-Navotas-M.Naval@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "509",

    "Old Store Names": "General Luis - Kaybiga",

    store_name: "General Luis-Kaybiga",

    main_email: "#RBG-Division9-GeneralLuis-Kaybiga@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "512",

    "Old Store Names": "Grace Park - 3rd Avenue",

    store_name: "Grace Park-3rd Ave.",

    main_email: "#RBG-Division9-GracePark-3rdAve@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "536",

    "Old Store Names": "Valenzuela - Gen. T. De Leon",

    store_name: "Valenzuela-Gen. T. De Leon",

    main_email: "#RBG-Division9-Valenzuela-GenTDeLeon@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "166",

    "Old Store Names": "Jose Abad Santos -Tayuman",

    store_name: "Jose Abad Santos-Tayuman",

    main_email: "#RBG-Division9-JoseAbadSantos-Tayuman@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "525",

    "Old Store Names": "Blumentritt - Rizal Avenue",

    store_name: "Blumentritt-Rizal Ave.",

    main_email: "#RBG-Division9-Blumentritt-RizalAve@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "67",

    "Old Store Names": "New Manila",

    store_name: "New Manila",

    main_email: "#RBG-Division10-NewManila@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "165",

    "Old Store Names": "E. Rodriguez",

    store_name: "E. Rodriguez Ave.",

    main_email: "#RBG-Division10-E.Rodriguez@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "42",

    "Old Store Names": "Tomas Morato",

    store_name: "Tomas Morato",

    main_email: "#RBG-Division10-TomasMorato@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "232",

    "Old Store Names": "Cubao - Araneta Center",

    store_name: "Cubao-Araneta Center",

    main_email: "#RBG-Division10-Cubao-AranetaCenter@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "537",

    "Old Store Names": "E. Rodriguez Ave. - Cubao",

    store_name: "E. Rodriguez Ave.-Cubao",

    main_email: "#RBG-Division10-E.RodriguezAve-Cubao@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "157",

    "Old Store Names": "Timog",

    store_name: "Timog Ave.",

    main_email: "#RBG-Division10-Timog@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "571",

    "Old Store Names": "Aurora Blvd.-Anonas",

    store_name: "Aurora Blvd.-Anonas",

    main_email: "#RBG-Division10-AuroraBlvd.-Anonas@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "562",

    "Old Store Names": "Kamuning",

    store_name: "Kamuning",

    main_email: "#RBG-Division10-Kamuning@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "570",

    "Old Store Names": "Timog-Mother Ignacia",

    store_name: "Timog-Mother Ignacia",

    main_email: "#RBG-Division10-Timog-MotherIgnacia@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "572",

    "Old Store Names": "Boni Serrano Ave.",

    store_name: "Boni Serrano Ave.",

    main_email: "#RBG-Division10-BoniSerranoAve@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "178",

    "Old Store Names": "Kamias",

    store_name: "Kamias",

    main_email: "#RBG-Division10-Kamias@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "56",

    "Old Store Names": "West Avenue",

    store_name: "West Avenue",

    main_email: "#RBG-Division10-WestAvenue@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "14",

    "Old Store Names": "Anonas",

    store_name: "Anonas",

    main_email: "#RBG-Division10-Anonas@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "2",

    "Old Store Names": "Cubao",

    store_name: "Cubao-P. Tuazon",

    main_email: "#RBG-Division10-Cubao@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "26",

    "Old Store Names": "Quezon Ave.",

    store_name: "Quezon Ave-Sct Santiago",

    main_email: "#RBG-Division10-QuezonAve@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "207",

    "Old Store Names": "Quezon Avenue - Dr. Garcia",

    store_name: "Quezon Ave-Dr. Garcia",

    main_email: "#RBG-Division10-QuezonAve.-Dr.Garcia@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "109",

    "Old Store Names": "South Triangle",

    store_name: "Quezon Ave-Sct Albano",

    main_email: "#RBG-Division10-SouthTriangle@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "3",

    "Old Store Names": "Ortigas",

    store_name: "F. Ortigas Jr.",

    main_email: "pbc_ortigas@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "7",

    "Old Store Names": "Pasig - Shaw",

    store_name: "Pasig-Shaw Blvd.",

    main_email: "pbc_pasigshaw@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "8",

    "Old Store Names": "Pasig-Kapasigan",

    store_name: "Pasig-Caruncho",

    main_email: "pbc_pasigpoblacion@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "49",

    "Old Store Names": "Tektite",

    store_name: "Tektite",

    main_email: "pbc_ortigastektite@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "88",

    "Old Store Names": "San Miguel Ave., Ortigas",

    store_name: "San Miguel Ave.",

    main_email: "pbc_ortigassanmiguel@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "112",

    "Old Store Names": "Emerald",

    store_name: "Ortigas-Emerald",

    main_email: "pbc_emerald@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "113",

    "Old Store Names": "C. Raymundo",

    store_name: "C. Raymundo Ave.",

    main_email: "pbc_craymundo@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "148",

    "Old Store Names": "Ortigas-Rockwell",

    store_name: "Ortigas-Rockwell",

    main_email: "LCSamera@eastwestbanker.com",

    copy_email_address: "GMTalavera@eastwestbanker.com",

    "": "",
  },

  {
    "Branch Code": "150",

    "Old Store Names": "Pasig Boulevard",

    store_name: "Pasig Boulevard",

    main_email: "#rbg-division11-pasigblvd@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "246",

    "Old Store Names": "Julia Vargas",

    store_name: "Julia Vargas",

    main_email: "#rbg-division11-juliavargas@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "255",

    "Old Store Names": "Garnet",

    store_name: "Ortigas-Garnet",

    main_email: "#rbg-division11-ortigas-garnet@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "258",

    "Old Store Names": "Pasig Valle Verde",

    store_name: "Silver City",

    main_email: "#rbg-division11-silvercity@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "259",

    "Old Store Names": "Pasig Rosario",

    store_name: "Pasig Rosario",

    main_email: "#rbg-division11-pasig-rosario@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "260",

    "Old Store Names": "Pasig - Santolan",

    store_name: "Pasig-Santolan",

    main_email: "#rbg-division11-pasig-santolan@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "556",

    "Old Store Names": "Pateros",

    store_name: "Pateros",

    main_email: "#rbg-division11-pateros@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "566",

    "Old Store Names": "Ortigas-ADB Avenue",

    store_name: "Ortigas-ADB Avenue",

    main_email: "#rbg-division11-ortigas-adbavenue@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "603",

    "Old Store Names": "Ortigas - Orient Square",

    store_name: "Ortigas - Orient Square",

    main_email: "#rbg-division11-ortigas-orientsquare@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "25",

    "Old Store Names": "Mandaluyong - Shaw",

    store_name: "Mandaluyong-Shaw Blvd.",

    main_email: "#RBG-Division12-Mandaluyong@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "31",

    "Old Store Names": "Annapolis",

    store_name: "Annapolis",

    main_email: "#RBG-Division12-Annapolis@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "46",

    "Old Store Names": "Greenhills",

    store_name: "Greenhills-West",

    main_email: "#RBG-Division12-Greenhills-West@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "102",

    "Old Store Names": "San Juan",

    store_name: "San Juan",

    main_email: "#RBG-Division12-SanJuan@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "107",

    "Old Store Names": "Pioneer",

    store_name: "Pioneer",

    main_email: "#RBG-Division12-Pioneer@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "119",

    "Old Store Names": "Mandaluyong - Libertad",

    store_name: "Mandaluyong-Libertad",

    main_email: "#RBG-Division12-MandaluyongLibertad@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "138",

    "Old Store Names": "Greenhills Shopping Center",

    store_name: "Greenhills Shopping Center",

    main_email: "#RBG-Division12-GreenhillsShoppingCenter@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "159",

    "Old Store Names": "Wilson",

    store_name: "Wilson",

    main_email: "#RBG-Division12-Wilson@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "175",

    "Old Store Names": "Connecticut",

    store_name: "Greenhills-Connecticut",

    main_email: "#RBG-Division12-Connecticut@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "216",

    "Old Store Names": "Boni Avenue",

    store_name: "Boni Avenue",

    main_email: "#RBG-Division12-BoniAvenue@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "272",

    "Old Store Names": "Greenhills-North",

    store_name: "Greenhills - North",

    main_email: "#RBG-Division12-Greenhills-North@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "273",

    "Old Store Names": "Mandaluyong - Wack-Wack",

    store_name: "Mandaluyong - Wack-Wack",

    main_email: "#RBG-Division12-Mandaluyong?Wack-Wack@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "278",

    "Old Store Names": "Kalentong",

    store_name: "Kalentong ",

    main_email: "#RBG-Division12-Kalentong@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "526",

    "Old Store Names": "Greenhills - Promenade",

    store_name: "Greenhills-Promenade",

    main_email: "#RBG-Division12-Greenhills-Promenade@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "30",

    "Old Store Names": "Festival Mall 1",

    store_name: "Festival Mall Level 2",

    main_email: "#RBG-Division14-FestivalMall2@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "36",

    "Old Store Names": "Westgate",

    store_name: "Alabang-Westgate",

    main_email: "#RBG-Division14-Westgate@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "51",

    "Old Store Names": "Festival Mall 2",

    store_name: "Festival Mall Level 1",

    main_email: "#RBG-Division14-FestivalMall1@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "89",

    "Old Store Names": "Alabang Madrigal",

    store_name: "Alabang Madrigal",

    main_email: "#RBG-Division14-AlabangMadrigal@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "122",

    "Old Store Names": "Muntinlupa",

    store_name: "Muntinlupa",

    main_email: "#RBG-Division14-Muntinlupa@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "146",

    "Old Store Names": "Alabang - Commerce Ave.",

    store_name: "Alabang-Commerce Ave.",

    main_email: "#RBG-Division14-Alabang-CommerceAve@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "215",

    "Old Store Names": "Alabang Entrata",

    store_name: "Alabang Entrata",

    main_email: "#RBG-Division14-Alabang-Entrata@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "290",

    "Old Store Names": "Alabang Hills",

    store_name: "Alabang Hills",

    main_email: "#RBG-Division14-AlabangHills@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "4",

    "Old Store Names": "Las Pinas",

    store_name: "Las Piñas-Pamplona",

    main_email: "#RBG-Division15-LasPinas@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "129",

    "Old Store Names": "Las Pinas - BF Resort",

    store_name: "Las Piñas-BF Resort",

    main_email: "#RBG-Division14-LasPinasBFResort@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "182",

    "Old Store Names": "Las Piñas - Marcos Alvarez Ave",

    store_name: "Las Piñas-Marcos Alvarez",

    main_email: "#RBG-Division15-LasPinas-MarcosAlvarezAve@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "271",

    "Old Store Names": "Las Pinas-Almanza",

    store_name: "Las Piñas-Almanza",

    main_email: "#RBG-Division14-LasPinas-Almanza@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "539",

    "Old Store Names": "Las Piñas-J.Aguilar Ave.",

    store_name: "Las Piñas-J.Aguilar Ave.",

    main_email: "#RBG-Division14-LasPinas-J.AguilarAve@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "601",

    "Old Store Names": "Alabang - Frabelle",

    store_name: "Alabang - Frabelle",

    main_email: "#RBG-Division14-Alabang-Frabelle@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "606",

    "Old Store Names": "Festival Mall – Expansion Wing",

    store_name: "Festival Mall – Expansion Wing",

    main_email: "#RBG-Division14-FSM3-ExpansionWing@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "12",

    "Old Store Names": "Better Living",

    store_name: "BetterLiving-Doña Soledad",

    main_email:
      "#rbg-division15-betterliving-donasoledadave_@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "15",

    "Old Store Names": "President's Avenue",

    store_name: "President's Avenue",

    main_email: "#rbg-division15-president'savenue@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "158",

    "Old Store Names": "West Service Road",

    store_name: "West Service Road",

    main_email: "#rbg-division15-westserviceroad@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "171",

    "Old Store Names": "Better Living - Doña Soledad Ave.",

    store_name: "Better Living-Peru",

    main_email: "#rbg-division15-betterliving@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "206",

    "Old Store Names": "BF Homes - Aguirre Ave",

    store_name: "BF Homes-Aguirre",

    main_email: "#rbg-division15-bfhomes-aguirreave@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "277",

    "Old Store Names": "Bicutan - East Service Road",

    store_name: "Bicutan-East Service Rd",

    main_email: "#rbg-division15-bicutan-eastserviceroad@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "43",

    "Old Store Names": "Sucat",

    store_name: "Sucat-NAIA",

    main_email: "#rbg-division15-sucat@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "161",

    "Old Store Names": "Sucat - Evacom",

    store_name: "Sucat-Evacom",

    main_email: "#rbg-division15-sucat-evacom@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "192",

    "Old Store Names": "Sucat - Kingsland",

    store_name: "Sucat-Kingsland",

    main_email: "#rbg-division15-sucatkingsland@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "274",

    "Old Store Names": "Sucat - Kabihasnan  ",

    store_name: "Sucat-Kabihasnan  ",

    main_email: "#rbg-division15-sucat-kabihasnan@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "538",

    "Old Store Names": "MIA Road",

    store_name: "MIA Road",

    main_email: "#rbg-division15-miaroad@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "291",

    "Old Store Names": "Marikina - Parang",

    store_name: "Marikina-Parang",

    main_email: "#RBG-Division16-Marikina-Parang@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "169",

    "Old Store Names": "Marikina - Concepcion",

    store_name: "Marikina-Concepcion",

    main_email: "#RBG-Division16-Marikina-Concepcion@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "569",

    "Old Store Names": "Montalban-Rizal",

    store_name: "Montalban-Rizal",

    main_email: "#RBG-Division16-Montalban-Rizal@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "143",

    "Old Store Names": "Taytay-Manila East",

    store_name: "Taytay-Manila East",

    main_email: "#RBG-Division16-Taytay-ManilaEast@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "137",

    "Old Store Names": "Marikina - Gil Fernando Ave.",

    store_name: "Marikina-Gil Fernando",

    main_email: "#RBG-Division16-Marikina-GilFernandoAve@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "11",

    "Old Store Names": "Taytay",

    store_name: "Taytay-Ortigas Ext.",

    main_email: "#RBG-Division16-Taytay@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "135",

    "Old Store Names": "Antipolo - M.L.Quezon",

    store_name: "Antipolo-ML Quezon",

    main_email: "#RBG-Division16-Antipolo-M.L.Quezon@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "16",

    "Old Store Names": "Marcos Highway",

    store_name: "Antipolo-Marcos Hi-way",

    main_email: "#RBG-Division16-MarcosHighway@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "251",

    "Old Store Names": "Marikina - J.P.Rizal",

    store_name: "Marikina-J.P. Rizal",

    main_email: "#RBG-Division16-Marikina-JPRizal@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "592",

    "Old Store Names": "San Mateo",

    store_name: "San Mateo",

    main_email: "#RBG-Division16-SanMateo@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "18",

    "Old Store Names": "Bagumbayan",

    store_name: "Bagumbayan",

    main_email: "#RBG-Division16-Bagumbayan@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "204",

    "Old Store Names": "Eastwood City",

    store_name: "Eastwood City",

    main_email: "#RBG-Division16-EastwoodCity@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "142",

    "Old Store Names": "Acropolis",

    store_name: "Acropolis",

    main_email: "#RBG-Division16-Acropolis@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "27",

    "Old Store Names": "Katipunan",

    store_name: "Katipunan-St. Ignatius",

    main_email: "#RBG-Division16-Katipunan@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "10",

    "Old Store Names": "Imus",

    store_name: "Imus",

    main_email: "pbc_imus@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "20",

    "Old Store Names": "Bacoor",

    store_name: "Bacoor-Aguinaldo Hi-way",

    main_email: "pbc_bacoor@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "106 ",

    "Old Store Names": "Carmona",

    store_name: "Carmona",

    main_email: "pbc_carmona@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "124 ",

    "Old Store Names": "Gen. Trias",

    store_name: "General Trias",

    main_email: "#RBG-Division15-GeneralTrias@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "210",

    "Old Store Names": "Bacoor - Molino",

    store_name: "Bacoor-Molino",

    main_email: "#RBG-Division15-Bacoor-Molino@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "221",

    "Old Store Names": "Cavite - Naic",

    store_name: "Cavite-Naic",

    main_email: "#RBG-Division15-Cavite-Naic@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "222",

    "Old Store Names": "Cavite - Tanza",

    store_name: "Cavite-Tanza",

    main_email: "#RBG-Division15-Cavite-Tanza@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "234",

    "Old Store Names": "Dasmariñas",

    store_name: "Dasmariñas",

    main_email: "#RBG-Division15-Dasmarinas@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "284",

    "Old Store Names": "Cavite City",

    store_name: "Cavite City",

    main_email: "#RBG-Division15-CaviteCity@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "299",

    "Old Store Names": "Cavite –Trece Martires",

    store_name: "Cavite-Trece Martires",

    main_email: "#RBG-Division15-Cavite-TreceMartires@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "517",

    "Old Store Names": "Cavite - Silang",

    store_name: "Cavite-Silang",

    main_email: "#RBG-Division15-Cavite-Silang@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "543",

    "Old Store Names": "Kawit-Centennial",

    store_name: "Kawit-Centennial",

    main_email: "#RBG-Division17-Kawit-Centennial@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "593",

    "Old Store Names": "Cavite - Rosario",

    store_name: "Cavite - Rosario",

    main_email: "#RBG-Division17-CaviteRosario@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "599",

    "Old Store Names": "Tagaytay",

    store_name: "Tagaytay",

    main_email: "#RBG-Division17-Tagaytay@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "34",

    "Old Store Names": "Lucena",

    store_name: "Lucena City",

    main_email: "pbc_lucena@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "55",

    "Old Store Names": "Batangas",

    store_name: "Batangas City",

    main_email: "pbc_batangas@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "78",

    "Old Store Names": "Lipa",

    store_name: "Lipa City",

    main_email: "pbc_lipa@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "214",

    "Old Store Names": "Batangas - Bauan",

    store_name: "Batangas-Bauan",

    main_email: "#RBG-Division18-Batangas-Bauan@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "220",

    "Old Store Names": "Mindoro - Calapan",

    store_name: "Mindoro-Calapan",

    main_email: "#RBG-Division18-Mindoro-Calapan@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "267",

    "Old Store Names": "Batangas - Tanauan",

    store_name: "Batangas-Tanauan",

    main_email: "#RBG-Division18-Batangas-Tanauan@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "502",

    "Old Store Names": "Batangas - Lemery",

    store_name: "Batangas-Lemery",

    main_email: "#RBG-Division18-Batangas-Lemery@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "511",

    "Old Store Names": "Batangas - Rosario",

    store_name: "Batangas-Rosario",

    main_email: "#RBG-Division18-Batangas-Rosario@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "530",

    "Old Store Names": "Batangas - Nasugbu",

    store_name: "Batangas-Nasugbu",

    main_email: "#RBG-Division18-Batangas-Nasugbu@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "544",

    "Old Store Names": "Batangas-Sto. Tomas",

    store_name: "Batangas-Sto. Tomas",

    main_email: "#RBG-Division18-Batangas-Sto.Tomas@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "552",

    "Old Store Names": "Batangas-Balayan",

    store_name: "Batangas-Balayan",

    main_email: "#RBG-Division18-Batangas-Balayan@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "580",

    "Old Store Names": "Batangas City - Pallocan",

    store_name: "Batangas City - Pallocan",

    main_email: "#RBG-Division18-BatangasCity-Pallocan@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "587",

    "Old Store Names": "Candelaria",

    store_name: "Candelaria",

    main_email: "#RBG-Division18-Candelaria@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "35",

    "Old Store Names": "Calamba",

    store_name: "Calamba",

    main_email: "#RBG-Division19-Calamba@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "58",

    "Old Store Names": "Naga",

    store_name: "Naga City",

    main_email: "#RBG-Division19-NagaCity@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "127",

    "Old Store Names": "San Pablo",

    store_name: "San Pablo",

    main_email: "acsalazar@eastwestbanker.com",

    copy_email_address: "rifabie@eastwestbanker.com",

    "": "",
  },

  {
    "Branch Code": "128",

    "Old Store Names": "San Pedro",

    store_name: "San Pedro",

    main_email: "#RBG-Division19-SanPedro@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "283",

    "Old Store Names": "Laguna-Cabuyao",

    store_name: "Laguna-Cabuyao",

    main_email: "#RBG-Division19-Laguna-Cabuyao@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "287",

    "Old Store Names": "Legazpi City",

    store_name: "Legazpi City",

    main_email: "#RBG-Division19-LegazpiCity@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "501",

    "Old Store Names": "Laguna - Biñan",

    store_name: "Laguna-Biñan",

    main_email: "#RBG-Division19-Laguna-Binan@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "545",

    "Old Store Names": "Sorsogon City",

    store_name: "Sorsogon City",

    main_email: "#RBG-Division19-SorsogonCity@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "558",

    "Old Store Names": "Sta. Rosa",

    store_name: "Sta. Rosa",

    main_email: "#RBG-Division19-Sta.Rosa@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "565",

    "Old Store Names": "Tabaco City",

    store_name: "Tabaco City",

    main_email: "#RBG-Division19-TabacoCity@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "583",

    "Old Store Names": "Calamba - National Road",

    store_name: "Calamba - National Road",

    main_email: "#RBG-Division19-Calamba-NationalRoad@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "582",

    "Old Store Names": "Laguna-Sta. Cruz",

    store_name: "Laguna-Sta. Cruz",

    main_email: "#RBG-Division19-Laguna-Sta.Cruz@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "32",

    "Old Store Names": "San Fernando ",

    store_name: "San Fernando-Dolores",

    main_email: "#RBG-Division20-SanFernando-Dolores@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "44",

    "Old Store Names": "Angeles, Pampanga",

    store_name: "Pampanga-Angeles City",

    main_email: "#RBG-Division20-AngelesPampanga@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "53",

    "Old Store Names": "Tarlac",

    store_name: "Tarlac-F. Tañedo",

    main_email: "#RBG-Division20-Tarlac-F.Tanedo@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "108",

    "Old Store Names": "Olongapo",

    store_name: "Olongapo City",

    main_email: "#RBG-Division20-OlongapoCity@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "120",

    "Old Store Names": "Balanga, Bataan",

    store_name: "Bataan-Balanga",

    main_email: "#RBG-Division20-BalangaBataan@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "167",

    "Old Store Names": "Pampanga - Apalit",

    store_name: "Pampanga-Apalit",

    main_email: "#RBG-Division20-Pampanga-Apalit@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "170",

    "Old Store Names": "Balibago - Angeles",

    store_name: "Angeles-Balibago",

    main_email: "#RBG-Division20-Angeles-Balibago@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "191",

    "Old Store Names": "Pampanga - San Fernando Sindalan",

    store_name: "San Fernando-Sindalan",

    main_email: "#RBG-Division20-SanFernandoSindalan@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "239",

    "Old Store Names": "Dinalupihan, Bataan",

    store_name: "Bataan-Dinalupihan",

    main_email: "#RBG-Division20-Bataan-Dinalupihan@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "243",

    "Old Store Names": "Guagua, Pampanga",

    store_name: "Pampanga-Guagua",

    main_email: "#RBG-Division20-Pampanga-Guagua@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "256",

    "Old Store Names": "Paniqui, Tarlac",

    store_name: "Tarlac-Paniqui",

    main_email: "#RBG-Division20-TarlacPaniqui@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "298",

    "Old Store Names": "Subic Bay",

    store_name: "Subic Bay",

    main_email: "#RBG-Division20-SubicBay@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "516",

    "Old Store Names": "San Fernando - Jose Abad Santos Avenue",

    store_name: "San Fernando-JASA",

    main_email: "#RBG-Division20-SanFernando-JASA@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "542",

    "Old Store Names": "Zambales - Iba",

    store_name: "Zambales-Iba",

    main_email: "#RBG-Division20-Zambales-Iba@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "561",

    "Old Store Names": "Bataan-Mariveles",

    store_name: "Bataan-Mariveles",

    main_email: "#RBG-Division20-Bataan-Mariveles@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "576",

    "Old Store Names": "Tarlac - Concepcion",

    store_name: "Tarlac - Concepcion",

    main_email: "#RBG-Division20-Tarlac-Concepcion@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "578",

    "Old Store Names": "Tarlac - McArthur Highway",

    store_name: "Tarlac - McArthur Highway",

    main_email: "#RBG-Division20-Tarlac-McArthurHighway@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "596",

    "Old Store Names": "Pampanga-Clark",

    store_name: "Pampanga-Clark",

    main_email: "#RBG-Division20-Pampanga-Clark@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "33",

    "Old Store Names": "Cabanatuan",

    store_name: "Cabanatuan-Melencio",

    main_email: "#RBG-Division19-Cabanatuan-Melencio@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "66",

    "Old Store Names": "Isabela",

    store_name: "Isabela-Santiago",

    main_email: "#RBG-Division19-Isabela-Santiago@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "76",

    "Old Store Names": "Baliuag, Bulacan",

    store_name: "Baliuag",

    main_email: "#RBG-Division19-Baliuag@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "83",

    "Old Store Names": "Cauayan, Isabela",

    store_name: "Isabela-Cauayan",

    main_email: "#RBG-Division19-Isabela-Cauayan@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "136",

    "Old Store Names": "Tuguegarao",

    store_name: "Tuguegarao City",

    main_email: "#RBG-Division19-TuguegaraCity@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "262",

    "Old Store Names": "San Jose Nueva ecija",

    store_name: "Nueva Ecija-San Jose",

    main_email: "#RBG-Division19-NuevaEcija-SanJose@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "263",

    "Old Store Names": "Solano, Nueva Vizcaya",

    store_name: "Nueva Vizcaya-Solano",

    main_email: "#RBG-Division19-NuevaVizcaya-Solano@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "282",

    "Old Store Names": "Bulacan - Plaridel",

    store_name: "Bulacan-Plaridel",

    main_email: "#RBG-Division19-Bulacan-Plaridel@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "288",

    "Old Store Names": "Nueva Ecija - Gapan",

    store_name: "Nueva Ecija-Gapan",

    main_email: "#RBG-Division19-NuevaEcija-Gapan@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "513",

    "Old Store Names": "Isabela - Ilagan",

    store_name: "Isabela-Ilagan",

    main_email: "#RBG-Division19-Isabela-Ilagan@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "541",

    "Old Store Names": "Nueva Ecija - Talavera",

    store_name: "Nueva Ecija-Talavera",

    main_email: "#RBG-Division19-NuevaEcija-Talavera@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "557",

    "Old Store Names": "Bulacan-San Jose Del Monte",

    store_name: "Bulacan-San Jose Del Monte",

    main_email: "#RBG-Division19-Bulacan-SanJoseDelMonte@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "573",

    "Old Store Names": "Cabanatuan-Maharlika",

    store_name: "Cabanatuan-Maharlika",

    main_email: "#RBG-Division21-Cabanatuan?Maharlika@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "577",

    "Old Store Names": "Bulacan - Sta. Maria",

    store_name: "Bulacan - Sta. Maria",

    main_email: "#RBG-Division19-Bulacan-Sta.Maria@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "253",

    "Old Store Names": "Meycauayan Bulacan",

    store_name: "Meycauayan-Malhacan",

    main_email: "#RBG-Division18-Meycauayan-Malhacan@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "297",

    "Old Store Names": "Balagtas - Bulacan",

    store_name: "Bulacan-Balagtas",

    main_email: "#RBG-Division18-Bulacan-Balagtas@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "540",

    "Old Store Names": "Malolos",

    store_name: "Malolos",

    main_email: "#RBG-Division18-Malolos@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "581",

    "Old Store Names": "Isabela - Roxas",

    store_name: "Isabela - Roxas",

    main_email: "#RBG-Division21-Isabela-Roxas@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "37",

    "Old Store Names": "Dagupan",

    store_name: "Dagupan-Perez",

    main_email: "#RBG-Division22-Dagupan-Perez@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "40",

    "Old Store Names": "Baguio",

    store_name: "Baguio-Rizal Monument",

    main_email: "#RBG-Division22-Baguio-Rizal Monument@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "59",

    "Old Store Names": "Laoag",

    store_name: "Laoag City",

    main_email: "#RBG-Division22-Laoag City@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "62",

    "Old Store Names": "La Union",

    store_name: "La Union-San Fernando",

    main_email: "#RBG-Division22-La Union-San Fernando@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "81",

    "Old Store Names": "Urdaneta",

    store_name: "Urdaneta City",

    main_email: "#RBG-Division22-Urdaneta City@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "149",

    "Old Store Names": "Pangasinan - San Carlos",

    store_name: "Pangasinan-San Carlos",

    main_email: "#RBG-Division22-Pangasinan-San Carlos@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "163",

    "Old Store Names": "Baguio - Session Road",

    store_name: "Baguio City-Session Rd.",

    main_email: "#RBG-Division22-Baguio City-Session Rd.@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "172",

    "Old Store Names": "Ilocos Sur - Candon",

    store_name: "Ilocos Sur-Candon",

    main_email: "#RBG-Division22-Ilocos Sur-Candon@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "218",

    "Old Store Names": "Rosales-Pangasinan",

    store_name: "Pangasinan-Rosales",

    main_email: "#RBG-Division22-Pangasinan-Rosales@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "233",

    "Old Store Names": "Dagupan - A.B. Fernandez Avenue",

    store_name: "Dagupan-A.B. Fernandez",

    main_email: "#RBG-Division22-Dagupan-A.B. Fernandez@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "247",

    "Old Store Names": "La Trinidad",

    store_name: "Benguet-La Trinidad",

    main_email: "#RBG-Division22-Benguet-LaTrinidad@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "269",

    "Old Store Names": "Vigan",

    store_name: "Vigan",

    main_email: "#RBG-Division22-Vigan@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "296",

    "Old Store Names": "Pangasinan - Lingayen",

    store_name: "Pangasinan-Lingayen",

    main_email: "#RBG-Division22-Pangasinan-Lingayen@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "514",

    "Old Store Names": "La Union - Agoo",

    store_name: "La Union-Agoo",

    main_email: "#RBG-Division22-La Union-Agoo@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "515",

    "Old Store Names": "Ilocos Norte - San Nicolas",

    store_name: "Ilocos Norte-San Nicolas",

    main_email: "#RBG-Division22-Ilocos Norte-San Nicolas@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "579",

    "Old Store Names": "Pangasinan - Mangaldan",

    store_name: "Pangasinan - Mangaldan",

    main_email: "#RBG-Division22-Pangasinan Mangaldan@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "586",

    "Old Store Names": "Pangasinan-Alaminos",

    store_name: "Pangasinan-Alaminos",

    main_email: "#RBG-Division22-Pangasinan-Alaminos@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "589",

    "Old Store Names": "Baguio - Legarda",

    store_name: "Baguio - Legarda",

    main_email: "#RBG-Division22-Baguio-Legarda@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "60",

    "Old Store Names": "Cebu Banilad",

    store_name: "Cebu-Banilad",

    main_email: "#RBG-Division23-Cebu-Banilad@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "41",

    "Old Store Names": "Cebu Escario",

    store_name: "Cebu-N. Escario",

    main_email: "#RBG-Division23-Cebu-N.Escario@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "139",

    "Old Store Names": "Cebu Grand Cenia",

    store_name: "Cebu-Grand Cenia",

    main_email: "#RBG-Division23-Cebu-GrandCenia@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "61",

    "Old Store Names": "Cebu Magallanes",

    store_name: "Cebu-Magallanes",

    main_email: "ebng@eastwestbanker.com",

    copy_email_address:
      "sbcuizon-hernaez@eastwestbanker.com;gcflores2@eastwestbanker.com",

    "": "",
  },

  {
    "Branch Code": "57",

    "Old Store Names": "Cebu - Mandaue",

    store_name: "Cebu-Mandaue Subangdaku",

    main_email: "pbc_cebumandaue@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "225",

    "Old Store Names": "Cebu Juan Luna",

    store_name: "Cebu-Colon",

    main_email: "#RBG-Division23-Cebu-Colon@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "230",

    "Old Store Names": "Cebu Magallanes - Noli Me Tangere",

    store_name: "Cebu-Freedom Park",

    main_email:
      "#RBG-Division23-CebuMagallanes-NoliMeTangere@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "174",

    "Old Store Names": "Cebu M. Velez",

    store_name: "Cebu-M. Velez",

    main_email: "#RBG-Division23-CebuMVelez@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "173",

    "Old Store Names": "Cebu AS Fortuna",

    store_name: "Cebu-A.S. Fortuna",

    main_email: "#RBG-Division23-CebuASFortuna@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "188",

    "Old Store Names": "Cebu Parkmall",

    store_name: "Cebu-Park Mall",

    main_email: "#RBG-Division23-Cebu-ParkMall@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "223",

    "Old Store Names": "Cebu Fuente Osmena",

    store_name: "Cebu-Fuente Osmeña",

    main_email: "#RBG-Division23-Cebu-FuenteOsmena@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "224",

    "Old Store Names": "Cebu - Asia Town IT Park",

    store_name: "Cebu IT Park",

    main_email: "#RBG-Division23-Cebu-AsiaTownITPark@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "598",

    "Old Store Names": "Cebu - Srp Il Corso",

    store_name: "Cebu - Srp Il Corso",

    main_email: "#RBG-Division23-CebuIlCorso@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "85",

    "Old Store Names": "Bacolod",

    store_name: "Bacolod-Lacson",

    main_email: "#RBG-Division24-Bacolod@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "131",

    "Old Store Names": "Iloilo Iznart",

    store_name: "Iloilo-Iznart",

    main_email: "#RBG-Division24-IloiloIznart@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "80",

    "Old Store Names": "Iloilo",

    store_name: "Iloilo-Ledesma",

    main_email: "#RBG-Division24-Iloilo@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "181",

    "Old Store Names": "Bacolod Mandalagan",

    store_name: "Bacolod-Mandalagan",

    main_email: "#RBG-Division24-Bacolod-Mandalagan@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "244",

    "Old Store Names": "Bacolod Hilado",

    store_name: "Bacolod-Hilado",

    main_email: "#RBG-Division21-Bacolod-Hilado@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "245",

    "Old Store Names": "Iloilo Jaro",

    store_name: "Iloilo-Jaro",

    main_email: "#RBG-Division24-Iloilo-Jaro@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "217",

    "Old Store Names": "Boracay",

    store_name: "Boracay",

    main_email: "#RBG-Division24-Boracay@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "505",

    "Old Store Names": "Kalibo",

    store_name: "Kalibo",

    main_email: "#RBG-Division24-Kalibo@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "504",

    "Old Store Names": "Roxas City",

    store_name: "Roxas City",

    main_email: "#RBG-Division24-RoxasCity@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "503",

    "Old Store Names": "Bacolod - Araneta",

    store_name: "Bacolod-Araneta",

    main_email: "#RBG-Division24-Bacolod-Araneta@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "510",

    "Old Store Names": "Antique - San Jose",

    store_name: "Antique-San Jose",

    main_email: "#RBG-Division24-Antique-SanJose@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "145",

    "Old Store Names": "Iloilo - Molo",

    store_name: "Iloilo-Molo",

    main_email: "#RBG-Division24-Iloilo-Molo@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "546",

    "Old Store Names": "Silay",

    store_name: "Silay",

    main_email: "#RBG-Division24-Silay@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "584",

    "Old Store Names": "Bacolod - East",

    store_name: "Bacolod - East",

    main_email: "#RBG-Division24-Bacolod-East@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "588",

    "Old Store Names": "Iloilo-Diversion",

    store_name: "Iloilo-Diversion",

    main_email: "#RBG-Division24-Iloilo-Diversion@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "70",

    "Old Store Names": "Davao Lanang",

    store_name: "Davao-Lanang",

    main_email: "#RBG-Division23-Davao-Lanang@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "71",

    "Old Store Names": "Davao Sta. Ana",

    store_name: "Davao-Sta. Ana",

    main_email: "#RBG-Division23-Davao-Sta.Ana@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "77",

    "Old Store Names": "Davao Matina",

    store_name: "Davao-Matina",

    main_email: "#RBG-Division23-Davao-Matina@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "134",

    "Old Store Names": "Davao Toril",

    store_name: "Davao-Toril",

    main_email: "#RBG-Division23-Davao-Toril@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "176",

    "Old Store Names": "Davao CM Recto",

    store_name: "Davao-C.M. Recto",

    main_email: "#RBG-Division23-Davao-C.M.Recto@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "211",

    "Old Store Names": "Davao Bajada",

    store_name: "Davao-Bajada",

    main_email: "#RBG-Division23-Davao-Bajada@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "235",

    "Old Store Names": "Davao JP Laurel",

    store_name: "Davao-J.P. Laurel",

    main_email: "#RBG-Division23-Davao-J.P.Laurel@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "285",

    "Old Store Names": "Davao - Buhangin",

    store_name: "Davao-Buhangin",

    main_email: "#RBG-Division23-Davao-Buhangin@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "518",

    "Old Store Names": "Davao - Agdao",

    store_name: "Davao-Agdao",

    main_email: "#RBG-Division23Davao-Agdao@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "519",

    "Old Store Names": "Davao - McArthur Matina",

    store_name: "Davao-McArthur Matina",

    main_email: "#RBG-Division23-Davao-McArthurMatina@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "547",

    "Old Store Names": "Davao - Quirino",

    store_name: "Davao-Quirino",

    main_email: "#RBG-Division23-Davao-Quirino@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "548",

    "Old Store Names": "Davao - Magsaysay",

    store_name: "Davao-Magsaysay",

    main_email: "#RBG-Division23-Davao-Magsaysay@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "585",

    "Old Store Names": "Davao-Diversion Road",

    store_name: "Davao-Diversion Road",

    main_email: "#RBG-Division23-Davao-DiversionRoad@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "594",

    "Old Store Names": "Davao-Ma-a",

    store_name: "Davao-Ma-a",

    main_email: "#RBG-Division25-Davao-Ma-a@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "123",

    "Old Store Names": "Butuan",

    store_name: "Butuan City",

    main_email: "#RBG-Division26-ButuanCity@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "38",

    "Old Store Names": "Cagayan De Oro",

    store_name: "Cagayan de Oro-Velez",

    main_email: "#RBG-Division26-CagayandeOro-Velez@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "111",

    "Old Store Names": "Iligan",

    store_name: "Iligan City",

    main_email: "#RBG-Division26-IliganCity@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "126",

    "Old Store Names": "Ozamiz",

    store_name: "Ozamiz City",

    main_email: "#RBG-Division26-OzamizCity@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "39",

    "Old Store Names": "Zamboanga",

    store_name: "Zamboanga-NS Valderrosa",

    main_email: "#RBG-Division26-Zamboanga-NSValderrosa@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "219",

    "Old Store Names": "Cagayan De Oro City - Cogon",

    store_name: "Cagayan de Oro-Cogon",

    main_email: "#RBG-Division26-CagayandeOro-Cogon@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "186",

    "Old Store Names": "Pagadian - FS Pajares Ave.",

    store_name: "Pagadian City",

    main_email: "#RBG-Division26-PagadianCity@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "270",

    "Old Store Names": "Zamboanga-Canelar",

    store_name: "Zamboanga L'Arcada",

    main_email: "#RBG-Division26-Zamboanga-L'Arcada@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "264",

    "Old Store Names": "Surigao City",

    store_name: "Surigao City",

    main_email: "#RBG-Division26-SurigaoCity@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "522",

    "Old Store Names": "Dipolog City",

    store_name: "Dipolog City",

    main_email: "#RBG-Division26-DipologCity@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "549",

    "Old Store Names": "Cagayan de Oro - Carmen",

    store_name: "Cagayan de Oro-Carmen",

    main_email: "#RBG-Division26-CagayandeOro-Carmen@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "550",

    "Old Store Names": "Cagayan de Oro - Lapasan",

    store_name: "Cagayan de Oro-Lapasan",

    main_email: "#RBG-Division26-CagayandeOro-Lapasan@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "591",

    "Old Store Names": "Butuan-P. Burgos",

    store_name: "Butuan-P. Burgos",

    main_email: "#RBG-Division26-Butuan-P.Burgos@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "604",

    "Old Store Names": "Cagayan De Oro - Pueblo de Oro",

    store_name: "Cagayan De Oro - Pueblo de Oro",

    main_email: "#RBG-Division26-CagayandeOro-PueblodeOro@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "226",

    "Old Store Names": "Cebu Minglanilla",

    store_name: "Cebu-Minglanilla",

    main_email: "#RBG-Division27-Cebu-Minglanilla@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "227",

    "Old Store Names": "Cebu Talisay",

    store_name: "Cebu-Talisay",

    main_email: "#RBG-Division27-Cebu-Talisay@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "229",

    "Old Store Names": "Cebu Basak Pardo",

    store_name: "Cebu-Basak Pardo",

    main_email: "#RBG-Division27-Cebu-BasakPardo@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "133",

    "Old Store Names": "Cebu Mandaue Northroad",

    store_name: "Cebu-Mandaue North Road",

    main_email: "#RBG-Division27-Cebu-MandaueNorthRoad@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "254",

    "Old Store Names": "Ormoc",

    store_name: "Ormoc City",

    main_email: "#RBG-Division27-OrmocCity@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "506",

    "Old Store Names": "Tacloban City - Marasbaras",

    store_name: "Tacloban City-Marasbaras",

    main_email: "#RBG-Division27-TaclobanCity-Marasbaras@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "590",

    "Old Store Names": "Tacloban-J. Romualdez",

    store_name: "Tacloban-J. Romualdez",

    main_email: "#RBG-Division27-Tacloban-J.Romualdez@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "265",

    "Old Store Names": "Tagbilaran",

    store_name: "Tagbilaran City",

    main_email: "#RBG-Division27-TagbilaranCity@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "529",

    "Old Store Names": "Catbalogan City",

    store_name: "Catbalogan City",

    main_email: "#RBG-Division27-CatbaloganCity@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "187",

    "Old Store Names": "Puerto Prinsesa - Rizal Ave.",

    store_name: "Palawan",

    main_email: "#RBG-Division27-PuertoPrincesa-RizalAve@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "240",

    "Old Store Names": "Dumaguete",

    store_name: "Dumaguete City",

    main_email: "#RBG-Division27-DumagueteCity@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "115",

    "Old Store Names": "Cebu Mactan",

    store_name: "Cebu Mactan",

    main_email: "#RBG-Division27-CebuMactan@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "228",

    "Old Store Names": "Cebu AC Cortes",

    store_name: "Cebu-A.C. Cortes",

    main_email: "#RBG-Division27-Cebu-ACCortes@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "179",

    "Old Store Names": "Koronadal",

    store_name: "Koronadal City",

    main_email: "#RBG-Division28-KoronadalCity@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "523",

    "Old Store Names": "General Santos City - Pioneer",

    store_name: "General Santos-Pioneer",

    main_email: "#RBG-Division28-GeneralSantos-Pioneer@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "553",

    "Old Store Names": "General Santos City-Calumpang",

    store_name: "General Santos City-Calumpang",

    main_email:
      "#RBG-Division28-GeneralSantosCity-Calumpang@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "117",

    "Old Store Names": "General Santos",

    store_name: "General Santos-Santiago",

    main_email: "#RBG-Division28-GeneralSantos-Santiago@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "63",

    "Old Store Names": "Cotabato",

    store_name: "Cotabato City",

    main_email: "#RBG-Division28-CotabatoCity@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "551",

    "Old Store Names": "Kidapawan",

    store_name: "Kidapawan",

    main_email: "#RBG-Division28-Kidapawan@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "281",

    "Old Store Names": "Bukidnon - Valencia",

    store_name: "Bukidnon-Valencia",

    main_email: "#RBG-Division28-Bukidnon-Valencia@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "597",

    "Old Store Names": "Tacurong",

    store_name: "Tacurong",

    main_email: "#RBG-Division28-Tacurong@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "236",

    "Old Store Names": "Davao Panabo",

    store_name: "Davao-Panabo City",

    main_email: "#RBG-Division28-Davao-PanaboCity@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "507",

    "Old Store Names": "Davao - Digos",

    store_name: "Davao-Digos",

    main_email: "#RBG-Division28-Davao-Digos@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },

  {
    "Branch Code": "152",

    "Old Store Names": "Davao - Tagum",

    store_name: "Tagum City",

    main_email: "#RBG-Division28-TagumCity@eastwestbanker.com",

    copy_email_address: "",

    "": "",
  },
];

export const store_locations = [
  {
    location: "NCR",
    store_name: "THE FORT - MARAJO TOWER",
    municipality: "TAGUIG",
    address:
      "G/F The Marajo Tower,  26th St. corner 4th Avenue, Fort Bonifacio, Global City Taguig",
    store_email: "pbc_fort@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "THE FORT - BURGOS CIRCLE",
    municipality: "TAGUIG",
    address:
      "G/F Units H & I, Crescent Park Residences, 30th St. corner 2nd Avenue, Bonifacio Global City, Taguig City.",
    store_email: "#RBG-Division1-TheFort-BurgosCircle@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "METROPOLITAN AVENUE",
    municipality: "MAKATI",
    address:
      "Savana Bldg 3 Metropolitan Avenue corner Venezia st. Bgy. Sta Cruz, Makati City ",
    store_email: "#RBG-Division1-MetropolitanAvenue@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "CHINO ROCES - BAGTIKAN",
    municipality: "MAKATI",
    address:
      "G/F High Pointe Bldg. No. 1184 Chino Roces Ave. near corner Bagtikan, Brgy. San Antonio, Makati City",
    store_email: "#RBG-Division1-ChinoRoces-Bagtikan@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "THE FORT - BEAUFORT",
    municipality: "TAGUIG",
    address:
      "The Beaufort G/F 5th Avenue Cor. 23rd St. Bonifacio Global City, Taguig City",
    store_email: "#RBG-Division1-TheFort-Beaufort@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "THE FORT - ACTIVE FUN",
    municipality: "TAGUIG",
    address:
      "G/F Active Fun Building, 9th Avenue corner 28th Street, City Center, Bonifacio Global City, Taguig City ",
    store_email: "#RBG-Division1-TheFort-ActiveFun@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "P. OCAMPO AVENUE",
    municipality: "MAKATI",
    address:
      "No. 245 P.Ocampo Ave. corner Flordeliz St., Brgy. La Paz, Makati City",
    store_email: "#RBG-Division1-P.OcampoAvenue@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "THE FORT - SOUTH OF MARKET",
    municipality: "TAGUIG",
    address:
      "G/F, Units 25 and 26, North Tower, South of Market (SOMA) Building, 26th St. cor. 11th Ave., Bonifacio Global City, Taguig City",
    store_email: "#RBG-Division1-TheFort26thSt-11thAve@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "THE FORT - F1 CENTER",
    municipality: "TAGUIG",
    address:
      "G/F, Unit D, F1 City Center, 32nd St.near corner 5th Avenue, Bonifacio Global City, Taguig City",
    store_email: "#RBG-Division1-TheFort-F1@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "THE FORT - BGC CORPORATE CENTER",
    municipality: "TAGUIG",
    address:
      "G/F, Unit No. 2, BGC Corporate Center, No. 3030 11th Ave. cor. 30th St., City Center, Bonifacio Global City, Taguig City 1634 ",
    store_email:
      "#RBG-Division1-TheFort-11thAvenue30thStreet@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "THE FORT-PSE TOWER",
    municipality: "TAGUIG",
    address:
      "5th Floor, One Bonifacio High Street – Philippine Stock Exchange Tower ( One BHS – PSE Tower), 5th Avenue cor. 28th Street, Bonifacio Global City, Taguig City",
    store_email: "#RBG-Division1-TheFort-PSETower@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "THE FORT - BRILLIANCE CENTER",
    municipality: "TAGUIG",
    address:
      "Unit 102 The Brilliance Center, 11th Avenue corner 40th Street, BGC, Taguig City",
    store_email: "#RBG-Division1-TheFort-BrillianceCenter@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "THE FORT - SEVEN NEO",
    municipality: "TAGUIG",
    address:
      '"Ground Floor, Shop C2 Seven Neo Building, 5th Avenue, Bonifacio Global City,  Taguig City',
    store_email: '"',
  },
  {
    location: "NCR",
    store_name: "PASONG TAMO EXT.",
    municipality: "MAKATI",
    address: "G/F Dacon Bldg., 2281 Pasong Tamo Extension, Makati City",
    store_email: "pbc_pasongtamo@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "PASEO DE ROXAS - LEGASPI",
    municipality: "MAKATI",
    address:
      "G/F, 111 Paseo De Roxas Bldg., 111 Paseo de Roxas St. corner Legaspi St., Legaspi Village, Makati City",
    store_email: "pbc_paseoderoxas@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "PASEO DE ROXAS - PHILAM TOWER",
    municipality: "MAKATI",
    address: "G/F, Philamlife Tower, 8767 Paseo de Roxas St., Makati City 1226",
    store_email: "PASEOPHILAMTOWER@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "AYALA AVENUE - SGV1",
    municipality: "MAKATI",
    address: "SGV 1 Bldg.,6760 Ayala Avenue, Makati City",
    store_email: "#RBG-Division2-AyalaAve.-SGV@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "RADA",
    municipality: "MAKATI",
    address:
      "G/F, Unit No. 102, La Maision Rada Condominium Bldg., Rada St., Legaspi Village, Makati City",
    store_email: "#RBG-Division2-Rada@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "BENAVIDEZ",
    municipality: "MAKATI",
    address:
      "Unit 103, One Corporate Plaza, Benavidez St. Legaspi Village, San Lorenzo, Makati City",
    store_email: "#RBG-Division2-Benavidez@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "AMORSOLO - QUEENSWAY",
    municipality: "MAKATI",
    address:
      "G/F Queensway Building, No.118 Amorsolo St., Legaspi Village, Makati City",
    store_email: "#RBG-Division2-Amorsolo-Queensway@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "AYALA AVENUE - RUFINO TOWER",
    municipality: "MAKATI",
    address:
      "G/F, Unit 1, Rufino Bldg., 6784 Ayala Ave. cor. V. A. Rufino St., Makati City",
    store_email: "#RBG-Division2-AyalaAve-Rufino@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "SAN LORENZO VILLAGE - A. ARNAIZ AVENUE",
    municipality: "MAKATI",
    address:
      "The E-Hotels Makati Bldg., No. 906 A. Arnaiz Ave., (formerly Pasay Rd.) San Lorenzo Village, Makati City",
    store_email: "#RBG-Division2-SanLorenzo-A.Arnaiz@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "PEREA",
    municipality: "MAKATI",
    address:
      "G/F Greenbelt Mansion, 106 Perea Street, Legaspi Village, Makati City",
    store_email: "#RBG-Division2-Perea@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "CHINO ROCES - LA FUERZA",
    municipality: "MAKATI",
    address:
      "Unit/s 10 & 11 La Fuerza Plaza 1, 2241 Don Chino Roces Avenue, Makati City",
    store_email: "#RBG-Division2-ChinoRoces-LaFuerza@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "LEGASPI - AGUIRRE",
    municipality: "MAKATI",
    address:
      "G/F, Unit 1-B, The Biltmore, No. 102 Aguirre Street, Legaspi Village, Makati City ",
    store_email: "#RBG-Division2-Legaspi-Aguirre@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "GIL PUYAT AVENUE",
    municipality: "MAKATI",
    address: "G/F Metro House Bldg., 345 Sen. Gil Puyat Ave., Makati City",
    store_email: "#RBG-Division3-GilPuyat@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "VALERO",
    municipality: "MAKATI",
    address:
      "G/F, Retail 1B, Paseo Park View Tower 1, 140 Valero St., Salcedo Village, Makati City",
    store_email: "pbc_valero@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "MAKATI AVENUE - PACIFIC STAR",
    municipality: "MAKATI",
    address: "G/F, Pacific Star Bldg., Sen Gil Puyat Ave. Makati City",
    store_email: "#RBG-Division3-MakatiAve.-PacificStar@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "MAKATI AVENUE - JUNO",
    municipality: "MAKATI",
    address:
      "Unit No. 2, A and W Building, No. 1 Juno St. corner Makati Avenue, Brgy. Bel-air, Makati City",
    store_email: "#RBG-Division3-MakatiAvenue@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "J.P. RIZAL",
    municipality: "MAKATI",
    address:
      "No. 805 J.P. Rizal cor. F. Zobel St., San Miguel Village, Makati City",
    store_email: "#RBG-Division3-JPRizal@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "H.V. DELA COSTA",
    municipality: "MAKATI",
    address:
      "Unit GFC-2, Classica 1 Condominium (“Building”), 112 H.V. Dela Costa St., Salcedo Village, Makati City",
    store_email: "#RBG-Division3-H.V.DelaCosta@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "JUPITER - PASEO DE ROXAS",
    municipality: "MAKATI",
    address:
      "No. 30 Jupiter cor. Paseo De Roxas Sts., Brgy. Bel-Air, Makati City",
    store_email: "#RBG-Division3-Jupiter-PaseodeRoxas@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "TORDESILLAS",
    municipality: "MAKATI",
    address:
      "Unit 105, Le Metropole Condominium, H.V. Dela Costa cor. and Tordesillas Sts. & Sen. Gil Puyat Ave., Salcedo Village, Makati City",
    store_email: "#RBG-Division3-Tordesillas@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "GIL PUYAT - SALCEDO VILLAGE",
    municipality: "MAKATI",
    address:
      "Unit 1C, G/F, Country Space 1 Bldg., Gil Puyat Avenue, Makati City",
    store_email: "#RBG-Division3-GilPuyat-SalcedoVill@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "LEVISTE",
    municipality: "MAKATI",
    address:
      "Unit Ground B, LPL Mansions Building, 122 L.P. Leviste Street, Salcedo Village Makati City",
    store_email: "#RBG-Division3-Leviste@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "AYALA AVENUE - HERRERA",
    municipality: "MAKATI",
    address:
      "G/F PBCom Tower, 6795 Ayala Ave. cor. V. Rufino St., (formerly Herrera St.), Salcedo Village, Makati City 1226",
    store_email: "#RBG-Division4-AyalaAvenue-Herrera@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "SALCEDO",
    municipality: "MAKATI",
    address:
      "G/F First Life Center, 174 Salcedo St.,Legaspi Village Makati City",
    store_email: "#RBG-Division3-GilPuyat-SalcedoVill@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "CHINO ROCES - DELA ROSA",
    municipality: "MAKATI",
    address:
      "G/F, King's Court II Bldg., No. 2129 Don Chino Roces Ave., cor Dela Rosa St., Makati City",
    store_email: "pbc_delarosa@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "LEGASPI - RUFINO",
    municipality: "MAKATI",
    address:
      '"G/F - Libran Bldg., Legaspi St. corner V.A. Rufino Ave.,Legaspi Village, Makati City"',

    store_email: "pbc_legaspi@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "EVANGELISTA",
    municipality: "MAKATI",
    address:
      "No. 1806 Evangelista St. corner Hen. Mojica St., Brgy. Bangkal, Makati City",
    store_email: "pbc_evangelista@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "GIL PUYAT - F.B. HARRISON",
    municipality: "PASAY CITY",
    address: "No. 131 Gil Puyat Avenue Extension, Brgy 24, Zone 4, Pasay City",
    store_email: "#RBG-Division4-GilPuyat-F.B.Harrison@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "PASAY - D. MACAPAGAL BLVD.",
    municipality: "PASAY CITY",
    address: "G/F The Biopolis, Macapagal Boulevard, Pasay City",
    store_email: "#RBG-Division4-Pasay-D.MacapagalBlvd@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "PASAY - LIBERTAD",
    municipality: "PASAY CITY",
    address: "Unit 265-E Nemar Building , Libertad St. Pasay City",
    store_email: "#RBG-Division4-Pasay-Libertad@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "LEGASPI - DELA ROSA",
    municipality: "MAKATI",
    address:
      "G/F, I - Care Bldg., No. 167 Legaspi cor Dela Rosa Sts., Legaspi Village, Makati City",
    store_email: "#RBG-Division4-Legaspi-DelaRosa@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "GIL PUYAT - DIAN",
    municipality: "MAKATI",
    address:
      "G/F, Wisma Cyberhub Building, No. 45 Sen. Gil Puyat Ave., Makati City",
    store_email: "#RBG-Division4-GilPuyat-Dian@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "PASAY - OCEANAIRE",
    municipality: "PASAY CITY",
    address:
      "Ground Floor Unit No. 108 & 109, Podium Commercial Area, Oceanaire Condominium, Sunrise Drive corner Rd. 23, SM Mall of Asia Complex, Pasay City",
    store_email: "#RBG-Division4-Pasay-Oceanaire@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "AYALA AVE. - MAKATI SKY PLAZA",
    municipality: "MAKATI",
    address: "G/F Makati Sky Plaza Bldg. 6788 Ayala Avenue Makati City ",
    store_email: "#RBG-Division4-AyalaAve-MakatiSkyPlaza@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "MAGALLANES VILLAGE",
    municipality: "MAKATI",
    address:
      "G/F Unit 102, Tritan Plaza Building, San Antonio St., Paseo De Magallanes, Makati City Philippines, 1232",
    store_email: "#RBG-Division4-PaseodeMagallanes@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "GIL PUYAT - WASHINGTON",
    municipality: "MAKATI",
    address:
      " No.100 Sen. Gil Puyat Avenue Corner Washington Street Brgy. Pio Del Pilar  Makati City 1230 Metro Manila",
    store_email: "#RBG-Division4-GilPuyat-Washington@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "STO. CRISTO",
    municipality: "MANILA CITY",
    address:
      "Unit 108, Sto. Cristo condominium, Sto Cristo corner Ilang-Ilang Sts., San Nicolas, Binondo, Manila",
    store_email: "pbc_stocristo@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "T. ALONZO",
    municipality: "MANILA CITY",
    address: "No. 623 T. Alonzo St., Brgy. 300, Zone 029, Sta. Cruz, Manila",
    store_email: "pbc_talonzo@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "BINONDO",
    municipality: "MANILA CITY",
    address: "G/F A. CBK Building, 493 Quintin Paredes St. Binondo Manila",
    store_email: "pbc_binondo@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "DIVISORIA",
    municipality: "MANILA CITY",
    address: "No. 802 Ilaya St., Binondo Manila",
    store_email: "pbc_divisoria@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "SOLER",
    municipality: "MANILA CITY",
    address: "G/F, R & S Tower, 941 Soler St., Binondo, Manila",
    store_email: "pbc_soler@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "168 MALL",
    municipality: "MANILA CITY",
    address:
      "4/F Unit 4H 09-11, 168 Mall Building 5, Soler St., Binondo, Manila",
    store_email: "#RBG-Division5-168Mall@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "CITY PLACE SQUARE",
    municipality: "MANILA CITY",
    address:
      "3/F C-P2-3, Cityplace Square, Reina Regente near corner Felipe II St., Binondo, Manila",
    store_email: "#RBG-Division5-CityplaceSquare@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "MASANGKAY",
    municipality: "MANILA CITY",
    address: "1411-1413 Masangkay St., Tondo, Manila",
    store_email: "#RBG-Division5-Masangkay@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "TOMAS MAPUA - LOPE DE VEGA",
    municipality: "MANILA CITY",
    address:
      "G/F & 2/F, Valqua Building., 1003 Tomas Mapua St. cor. Lope de Vega St., Sta. Cruz, Manila",
    store_email: "#RBG-Division5-TomasMapua?LopedeVega@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "999 SHOPPING MALL",
    municipality: "MANILA CITY",
    address:
      "3/f, Unit 10 & 3C-2, 999 Shopping Mall 2, C.M. Recto Street, Tondo Manila",
    store_email: "#RBG-Division5-999ShoppingMall@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "ELCANO",
    municipality: "MANILA CITY",
    address:
      "G/F, Elcano Plaza Building, No. 622 ElCano Street, Binondo, Manila",
    store_email: "#RBG-Division5-ElCano@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "JUAN LUNA - PRITIL",
    municipality: "MANILA CITY",
    address: "G/F 1953-1955 Juan Luna St., Tondo, Manila",
    store_email: "#RBG-Division5-JuanLuna-Pritil@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "ONGPIN",
    municipality: "MANILA CITY",
    address:
      "g/f, Unit G1, Strata Gold Condominium Bldg., No. 738 Ongpin St., Binondo, Manila",
    store_email: "#RBG-Division5-Ongpin@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "YLAYA - PADRE RADA",
    municipality: "MANILA CITY",
    address:
      "G/F Josefa Building No. 981, Ylaya Street corner Padre Rada Street Tondo, Manila",
    store_email: "#RBG-Division5-Ylaya-PadreRada@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "JUAN LUNA - BINONDO",
    municipality: "MANILA CITY",
    address: "No. 580 Juan Luna St. Binondo Manila",
    store_email: "#RBG-Division5-JuanLuna-Binondo@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "PADRE FAURA",
    municipality: "MANILA CITY",
    address:
      "G/F, Units A-D, Metrosquare Bldg. 2, No. 1241 M.H. Del Pilar St. corner Padre Faura St., Ermita, Manila",
    store_email: "pbc_padrefaura@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "ESCOLTA",
    municipality: "MANILA CITY",
    address:
      "Unit 3, G/F, First United Bldg., 413 Escolta corner Banquero St., Binondo, Manila",
    store_email: "#RBG-Division6-Escolta@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "INTRAMUROS",
    municipality: "MANILA CITY",
    address:
      "G/F, BF Condominium, 104 A. Soriano Avenue corner Solana St., Intramuros, Manila",
    store_email: "pbc_intramuros@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "UN AVENUE",
    municipality: "MANILA CITY",
    address:
      "MAGCOOP Bldg., UN Avenue St. near corner A. Mabini St., Ermita, Manila",
    store_email: "pbc_unavenue@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "BACLARAN",
    municipality: "PASAY CITY",
    address:
      "2/F, New Galleria Baclaran Shopping Mall, LRT South Terminal, Taft Ave. Extension, Pasay City",
    store_email: "#RBG-Division6-Baclaran@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "PACO",
    municipality: "MANILA CITY",
    address: "No. 1050 Pedro Gil St., Paco, Manila",
    store_email: "pbc_paco@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "ROXAS BOULEVARD",
    municipality: "MANILA CITY",
    address: "1437GF Sunny Bay Suites, Roxas Blvd., Ermita, Manila",
    store_email: "pbc_roxasblvd@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "TAFT - NAKPIL",
    municipality: "MANILA CITY",
    address:
      "RLR Building, 1820 Taft Avenue near corner Nakpil Street, Malate, Manila",
    store_email: "#RBG-Division6-Taft-Nakpil@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "TAFT AVENUE",
    municipality: "MANILA CITY",
    address:
      "Philippine Academy of Family Physicians (PAFP) Bldg. 2244 Taft Avenue, Manila",
    store_email: "#RBG-Division6-TaftAvenue@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "T.M. KALAW",
    municipality: "MANILA CITY",
    address: "A-1,2,3 & 4 Ditz Bldg., 444 T.M. Kalaw St., Ermita, Manila",
    store_email: "#RBG-Division6-T.M.Kalaw@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "QUIAPO",
    municipality: "MANILA CITY",
    address:
      "Raon Commercial Center,611 Quezon Blvd. near corner Raon St.,Quiapo, Manila",
    store_email: "#RBG-Division6-Quiapo@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "PAZ M. GUAZON",
    municipality: "MANILA CITY",
    address:
      "Units 5 & 6 Topmark Bldg., 1763 Paz M. Guazon Street, Paco, Manila",
    store_email: "#RBG-Division6-PazM.Guazon@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "SAMPALOC - J. FIGUERAS",
    municipality: "MANILA CITY",
    address: "No. 427-433 J. Figueras Street, Sampaloc, Manila",
    store_email: "#RBG-Division6-Sampaloc-J.Figueras@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "PEDRO GIL",
    municipality: "MANILA CITY",
    address: "No. 574 Pedro Gil Street, Malate Manila",
    store_email: "#RBG-Division6-PedroGil@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "A.MABINI - R.SALAS",
    municipality: "MANILA CITY",
    address:
      "G/F & 2/F Jesselton Tower No. 1453 A. Mabini St., corner R. Salas St., Brgy. 668, Zone 72, Ermita Manila",
    store_email: "#RBG-Division6-A.Mabini-R.Salas@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "CONGRESSIONAL AVE.",
    municipality: "QUEZON CITY",
    address: "Congressional Ave. Brgy. Bahay Toro Project 8, Quezon City",
    store_email: "#RBG-Division7-Congressional@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "REGALADO",
    municipality: "QUEZON CITY",
    address: "Regalado Ave. Cor. Archer St., North Fairview Subd. Quezon City",
    store_email: "#RBG-Division7-Regalado@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "TANDANG SORA",
    municipality: "QUEZON CITY",
    address:
      "Lot 80 - A Kalaw Hills Subd. Brgy. Culiat Tandang Sora Quezon City",
    store_email: "#RBG-Division7-TandangSora@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "NOVALICHES - GULOD",
    municipality: "QUEZON CITY",
    address: "Lot 489-B2 Quirino Highway, Brgy. Gulod, Novaliches, Quezon City",
    store_email: "#RBG-Division7-Novaliches@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "DON ANTONIO HEIGHTS",
    municipality: "QUEZON CITY",
    address:
      "Lot 24 Block 7, Holy Spirit Drive, Don Antonio Heights Brgy. Holy Spirit Quezon City",
    store_email: "#RBG-Division7-DonAntonio@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "BAESA TOWN CENTER",
    municipality: "QUEZON CITY",
    address:
      "Baesa Town Center Retail Store#4 #232 Quirino Highway Baesa Quezon City",
    store_email: "#RBG-Division7-BaesaTownCenter@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "UP VILLAGE",
    municipality: "QUEZON CITY",
    address: "No. 65 Maginhawa St., U.P. Village, Diliman, quezon City",
    store_email: "#RBG-Division7-UPVillage@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "COMMONWEALTH",
    municipality: "QUEZON CITY",
    address:
      "G/F, Crissant Plaza Bldg., No. 272 Commonwealth Ave., Brgy. Old Balara, Quezon City",
    store_email: "#RBG-Division7-Commonwealth@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "FAIRVIEW",
    municipality: "QUEZON CITY",
    address:
      "No. 72 Commonwealth Ave. corner Camaro St., East Fairview. Quezon City",
    store_email: "#RBG-Division7-Fairview@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "LAGRO",
    municipality: "QUEZON CITY",
    address: "Lot 2-B-6 Quirino Highway, Lagro, Novaliches, Quezon City",
    store_email: "#RBG-Division7-Lagro@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "LOYOLA HEIGHTS - KATIPUNAN",
    municipality: "QUEZON CITY",
    address:
      "Unit 13, Elizabeth Hall Bldg., Lot 1 Blk.41, Katipunan Avenue, Loyola Heights, Quezon City",
    store_email: "#RBG-Division7-LoyolaHeights-Katipunan@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "NOVALICHES - TALIPAPA",
    municipality: "QUEZON CITY",
    address:
      "G/F Units C, D, E, F & G No. 526 Quirino Highway, Brgy. Talipapa, Novaliches, Quezon City",
    store_email: "#RBG-Division7-Novaliches-Talipapa@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "VISAYAS AVENUE",
    municipality: "QUEZON CITY",
    address:
      "G/F, K.L. Group Bldg., Units B, C, & D, No. 15 Visayas Ave., Brgy. Vasra, Quezon City",
    store_email: "#RBG-Division7-VisayasAvenue2@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "PROJECT 8 - SHORTHORN",
    municipality: "QUEZON CITY",
    address:
      "G/F, West Star Business Center Bldg., No. 31 Shorthorn St., Brgy. Bahay Toro, Project 8, Quezon City",
    store_email: "#RBG-Division7-Project8-Shorthorn@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "XAVIERVILLE",
    municipality: "QUEZON CITY",
    address:
      "No. 60 Xavierville Avenue, Xavierville Subdivision, Brgy. Loyola Heights, Quezon City",
    store_email: "#RBG-Division7-Xavierville@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "KALAYAAN - MATALINO",
    municipality: "QUEZON CITY",
    address:
      "No. 123 Kalayaan Avenue near corner Matalino St. Brgy. Central Diliman, Quezon City",
    store_email: "#RBG-Division7-Kalayaan-Matalino@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "ROOSEVELT - FRISCO",
    municipality: "QUEZON CITY",
    address: "No. 184 Roosevelt Avenue, San Francisco Del Monte, Quezon City",
    store_email: "#RBG-Division8-Roosevelt@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "QUEZON AVENUE - BANAWE",
    municipality: "QUEZON CITY",
    address: "G/F PPSTA 1 Building Quezon Ave. cor. Banawe St., Quezon City",
    store_email: "#RBG-Division8-Banawe@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "DEL MONTE",
    municipality: "QUEZON CITY",
    address: "271 Del Monte cor. Biak na Bato, Quezon City",
    store_email: "#RBG-Division8-DelMonte@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "A. BONIFACIO - BALINTAWAK",
    municipality: "QUEZON CITY",
    address: "659 A.Bonifacio Ave., Balintawak, Quezon City",
    store_email: "#RBG-Division8-A.Bonifacio-Balintawak@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "MAYON",
    municipality: "QUEZON CITY",
    address: "No. 170 Mayon Avenue, Quezon City",
    store_email: "#RBG-Division8-Mayon@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "BANAWE - SCT. ALCARAZ",
    municipality: "QUEZON CITY",
    address:
      "Unit ABC G/F #740 Banawe Ave. near cor. Scout Alcaraz, Quezon City",
    store_email: "#RBG-Division8-Banawe-Sct.Alcaraz@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "BANAWE - N. ROXAS",
    municipality: "QUEZON CITY",
    address: "No. 42 Banawe Ave. cor. Nicanor Roxas, Quezon City",
    store_email: "#RBG-Division8-Banawe-N.Roxas@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "EDSA - HOWMART",
    municipality: "QUEZON CITY",
    address:
      "No. 1264 EDSA near corner Howmart Road, Brgy. A. Samson, Quezon City",
    store_email: "#RBG-Division8-EDSA-Howmart@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "EDSA - MUÑOZ",
    municipality: "QUEZON CITY",
    address:
      "G/F Lemon Square Bldg., 1199 EDSA Muñoz, Bgry. Katipunan, Quezon City",
    store_email: "#RBG-Division8-EDSA-Munoz@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "MASAMBONG",
    municipality: "QUEZON CITY",
    address:
      "L.G. Atkimson Bldg., No. 627 Del Monte Ave., Brgy. Masambong, Quezon City",
    store_email: "#RBG-Division8-Masambong@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "ROOSEVELT - STO. NIÑO",
    municipality: "QUEZON CITY",
    address:
      "282 Roosevelt Avenue, Brgy. Sto. Niño, San Francisco Del Monte, Quezon City",
    store_email: "#RBG-Division8-Roosevelt-Sto.Nino@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "G. ARANETA AVENUE",
    municipality: "QUEZON CITY",
    address:
      "Units A & B, Ilo Bldg., No. 195 G. Araneta Ave., Brgy. Santol, Quezon City",
    store_email: "#RBG-Division8-G.AranetaAvenue@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "NORTH EDSA",
    municipality: "QUEZON CITY",
    address:
      "UGF units 4,5,6&7 EDSA Grand Residences, EDSA cor. Corregidor St., Quezon City",
    store_email: "#RBG-Division8-NorthEDSA@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "A. BONIFACIO - BALINGASA",
    municipality: "QUEZON CITY",
    address:
      "G/F, 2/F & 3/F, Units D & E, Winston Building, No. 880 A. Bonifacio Avenue, Brgy. Balingasa, Quezon City",
    store_email: "#RBG-Division8-A.Bonifacio-Balingasa@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "BANAWE - KALIRAYA",
    municipality: "QUEZON CITY",
    address:
      "Titan 168 Building, 126 Banawe Street near corner Kaliraya St., Brgy. Tatalon, Quezon City",
    store_email: "#RBG-Division8-Banawe-Kaliraya@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "DEL MONTE - D. TUAZON",
    municipality: "QUEZON CITY",
    address: "No. 155 Del Monte Ave., Brgy. Manresa, Quezon City",
    store_email: "#RBG-Division8-DelMonte-D.Tuazon@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "MAYON - DAPITAN",
    municipality: "QUEZON CITY",
    address:
      "No. 181  Mayon St. near corner Dapitan St. Brgy. Sta. Teresita Quezon City",
    store_email: "#RBG-Division8-Mayon-Dapitan@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "E.ROD. - WELCOME ROTONDA",
    municipality: "QUEZON CITY",
    address:
      "G/F, AEK Bldg., No. 40 E. Rodriguez Sr. Ave., Brgy. Don Manuel, Quezon City",
    store_email: "#RBG-Division8-E.Rod.-WelcomeRotonda@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "EDSA - KALOOKAN",
    municipality: "CALOOCAN CITY",
    address: "No. 490 EDSA, Kalookan City",
    store_email: "#RBG-Division9-Edsa-Kalookan@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "VALENZUELA - MARULAS",
    municipality: "VALENZUELA CITY",
    address:
      "JLB Enterprises Bldg., KM 12 McArthur Highway, Marulas, Valenzuela City",
    store_email: "#RBG-Division9-Valenzuela-Marulas@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "GRACE PARK - 8TH AVE.",
    municipality: "CALOOCAN CITY",
    address: "No. 896 8th Avenue cor. J. Teodoro, Grace Park, Caloocan City",
    store_email: "#RBG-Division9-GracePark@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "PASO DE BLAS",
    municipality: "VALENZUELA CITY",
    address: "No. 191 Paso De Blas, Valenzuela City",
    store_email: "#RBG-Division9-PasodeBlas@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "MALABON - GOV. PASCUAL",
    municipality: "MALABON",
    address: "Gov. Pascual, Malabon",
    store_email: "#RBG-Division9-Gov.Pascual@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "MALABON - POTRERO",
    municipality: "MALABON",
    address:
      "Unit 1 & 2 Mary Grace Bldg. No. 142 Mac Arthur Highway, Potrero, Malabon ",
    store_email: "#RBG-Division9-Potrero@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "NAVOTAS - NORTH BAY",
    municipality: "NAVOTAS",
    address:
      "G/F, Unit 2 Melandria III Building, No. 1090 Northbay Blvd., Navotas City",
    store_email: "#RBG-Division9-NorthbayNavotas@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "CALOOCAN - A. MABINI",
    municipality: "CALOOCAN CITY",
    address:
      "G/F Gee Bee Bldg. No. 428 A. Mabini St., Brgy. 15, Zone 2, Caloocan City",
    store_email: "#RBG-Division9-Caloocan-A.Mabini@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "JOSE ABAD SANTOS - TAYUMAN",
    municipality: "MANILA CITY",
    address:
      "G/F & 2/F Cada Bldg., 1200 Tayuman St., cor. Jose Abad Santos Ave.Tondo, Manila",
    store_email: "#RBG-Division9-JoseAbadSantos-Tayuman@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "GRACE PARK - 7TH AVE.",
    municipality: "CALOOCAN CITY",
    address:
      "G/F Units 1,2, & 3 No. 330 Rizal Ave. Ext., near cor. 7th Avenue, East Grace Park, Caloocan City",
    store_email: "#RBG-Division9-Gracepark-7thAvenue@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "MALABON - RIZAL AVENUE",
    municipality: "MALABON",
    address: "No. 726 Rizal Ave., Brgy. Tanong, Malabon City",
    store_email: "#RBG-Division9-Malabon-RizalAvenue@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "GRACE PARK - 11TH AVE.",
    municipality: "CALOOCAN CITY",
    address:
      "G/F, Remcor V Building, Block 172, Lot 5, Rizal Avenue Ext., Caloocan City",
    store_email: "#RBG-Division9-Gracepark-11thAvenue@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "VALENZUELA - DALANDANAN",
    municipality: "VALENZUELA CITY",
    address:
      "Malanday Machinery's Commercial Bldg., No. 212 Km. 15 Mac Arthur Highway, Brgy. Dalandanan, Valenzuela City",
    store_email: "#RBG-Division9-Valenzuela-Dalandanan@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "NAVOTAS - M. NAVAL",
    municipality: "NAVOTAS",
    address: "No. 895 M. Naval Street, Brgy. Sipac-Almasen, Navotas City",
    store_email: "#RBG-Division9-Navotas-M.Naval@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "GENERAL LUIS - KAYBIGA",
    municipality: "CALOOCAN CITY",
    address: "No. 4 Gen. Luis St., Barangay Kaybiga, Caloocan City",
    store_email: "#RBG-Division9-GeneralLuis-Kaybiga@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "GRACE PARK - 3RD AVE.",
    municipality: "CALOOCAN CITY",
    address:
      "No. 215 Rizal Avenue Ext. Brgy. 45 Grace Park West, Caloocan City",
    store_email: "#RBG-Division9-GracePark-3rdAve@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "BLUMENTRITT - RIZAL AVENUE",
    municipality: "MANILA CITY",
    address: "No. 2412 Rizal Avenue, Sta. Cruz, Manila",
    store_email: "#RBG-Division9-Blumentritt-RizalAve@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "VALENZUELA - GEN. T. DE LEON",
    municipality: "VALENZUELA CITY",
    address:
      "G/F, Units 4 & 5, Liu Shuang Yu Bldg., No. 3026 Gen. T. De Leon St., Brgy. Gen. T. De Leon, Valenzuela City",
    store_email: "#RBG-Division9-Valenzuela-GenTDeLeon@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "CUBAO - P. TUAZON AVENUE",
    municipality: "QUEZON CITY",
    address:
      "G/F, Prince John Condominium, No. 291 P. Tuazon Ave.corner 18th Ave., Cubao, Quezon City",
    store_email: "#RBG-Division10-Cubao@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "ANONAS",
    municipality: "QUEZON CITY",
    address: "No. 94 Anonas Street corner K-6th, East Kamias, Quezon City",
    store_email: "#RBG-Division10-Anonas@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "QUEZON AVENUE - SCOUT SANTIAGO",
    municipality: "QUEZON CITY",
    address:
      "Unit No. 2G-7 and 2G-8, Sunshine Boulevard Plaza, No. 1328 Quezon Ave. cor. Scout Santiago St., Brgy. South Triangle, Quezon City",
    store_email: "#RBG-Division10-QuezonAve@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "TOMAS MORATO",
    municipality: "QUEZON CITY",
    address:
      "No. 257 Tomas Morato St. near cor. Scout Fuentabella, Quezon City",
    store_email: "#RBG-Division10-TomasMorato@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "WEST AVENUE",
    municipality: "QUEZON CITY",
    address:
      "No. 108 West Avenue corner West Lawin Street, West Triangle, Quezon City",
    store_email: "#RBG-Division10-WestAvenue@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "NEW MANILA",
    municipality: "QUEZON CITY",
    address: "G/F, AAP Building, No. 683 Aurora Blvd  New Manila Quezon City",
    store_email: "#RBG-Division10-NewManila@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "QUEZON AVENUE - SCOUT ALBANO",
    municipality: "QUEZON CITY",
    address:
      "Quezon Ave., near cor. Scout Albano, Bgy. South Triangle, Quezon City",
    store_email: "#RBG-Division10-SouthTriangle@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "TIMOG AVENUE",
    municipality: "QUEZON CITY",
    address: "G/F Timog Arcade,Timog Avenue cor. Sct. Torillo, Quezon City",
    store_email: "#RBG-Division10-Timog@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "E. RODRIGUEZ AVE.",
    municipality: "QUEZON CITY",
    address:
      "G/F MC RILLO BLDG. No. 1168 E. Rodriguez Ave.,Brgy. Mariana Quezon City",
    store_email: "#RBG-Division10-E.Rodriguez@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "KAMIAS",
    municipality: "QUEZON CITY",
    address:
      "No. 10 Kamias Rd., cor. Col Salgado St., Brgy. West Kamias, Quezon City",
    store_email: "#RBG-Division10-Kamias@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "QUEZON AVENUE - DR. GARCIA SR.",
    municipality: "QUEZON CITY",
    address:
      "G/F, Kayumanggi Press Bldg., No. 940 Quezon Ave., near cor. Dr. Garcia St., Brgy. Paligsahan Quezon City",
    store_email: "#RBG-Division10-QuezonAve.-Dr.Garcia@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "CUBAO - ARANETA CENTER",
    municipality: "QUEZON CITY",
    address:
      "G/F, Philamlife Building, Aurora Blvd. corner General Araneta Street, Cubao, Quezon City",
    store_email: "#RBG-Division10-Cubao-AranetaCenter@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "E. RODRIGUEZ AVE. - CUBAO",
    municipality: "QUEZON CITY",
    address:
      "No. 1731 E. Rodriguez Sr. Avenue, Brgy. Pinagkaisahan, Cubao, Quezon City",
    store_email: "#RBG-Division10-E.RodriguezAve-Cubao@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "KAMUNING",
    municipality: "QUEZON CITY",
    address: "JPY Bldg, No. 52 Kamuning Road, Brgy Kamuning Quezon City",
    store_email: "#RBG-Division10-Kamuning@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "TIMOG - MOTHER IGNACIA",
    municipality: "QUEZON CITY",
    address: "No. 21 Timog Ave., Brgy. South Triangle,  Quezon City 1103",
    store_email: "#RBG-Division10-Timog-MotherIgnacia@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "AURORA BLVD. - ANONAS",
    municipality: "QUEZON CITY",
    address:
      "Rosario Building, No. 999 Aurora Blvd., near corner Lauan and Anonas Sts., Bgy. Duyan-duyan, Project 3, Quezon City",
    store_email: "#RBG-Division10-AuroraBlvd.-Anonas@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "BONI SERRANO AVE.",
    municipality: "QUEZON CITY",
    address: "No. 107 Boni Serrano Avenue, Brgy. Lipunan ng Crame, Quezon City",
    store_email: "#RBG-Division10-BoniSerranoAve@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "EMERALD - GARNET",
    municipality: "PASIG",
    address:
      "Unit G103, g/f, AIC Gold Tower Condominium, F. Ortigas, Jr. Road, corner Garnet and Sapphire Sts., Ortigas Center. Pasig City",
    store_email: "#rbg-division11-ortigas-garnet@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "PASIG - SHAW BLVD",
    municipality: "PASIG",
    address:
      "Units A&B Karina Bldg., No. 33 Shaw Blvd., Brgy. San Antonio, District 1, Pasig City",
    store_email: "pbc_pasigshaw@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "PASIG - KAPASIGAN",
    municipality: "PASIG",
    address: "SG Bldg Caruncho Ave. Cor. Market Ave. San Nicolas Pasig City",
    store_email: "pbc_pasigpoblacion@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "TEKTITE",
    municipality: "PASIG",
    address:
      "G/F, East Tower, PSE Center, Exchange Drive, Ortigas Center, Pasig City",
    store_email: "pbc_ortigastektite@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "SAN MIGUEL AVE.",
    municipality: "PASIG",
    address:
      "G/F, Medical Plaza Building, San Miguel Avenue, Ortigas Center, Pasig City",
    store_email: "pbc_ortigassanmiguel@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "EMERALD",
    municipality: "PASIG",
    address:
      "G/F, Unit 103 Hanston Bldg., Don F. Ortigas Jr. Road, Ortigas Center, Pasig City ",
    store_email: "pbc_emerald@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "C. RAYMUNDO AVENUE",
    municipality: "PASIG",
    address: "JG Bldg. C. Raymundo Ave. Brgy Rosario Pasig City",
    store_email: "pbc_craymundo@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "ORTIGAS - ROCKWELL",
    municipality: "PASIG",
    address:
      "Unit No. W-01 Tower 1, The Rockwell Business Center, Ortigas Avenue, Pasig",
    store_email: "#RBG-Division11-Ortigas?Rockwell@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "PASIG - PASIG BLVD.",
    municipality: "PASIG",
    address:
      "Corner Pasig Blvd. and Lakeview Drive, Brgy. Bagong Ilog, Pasig City",
    store_email: "#rbg-division11-pasigblvd@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "JULIA VARGAS",
    municipality: "PASIG",
    address:
      "G/F, Unit 101 One Corporate Centre Office Condominium, Doña Julia Vargas Avenue corner Meralco Avenue, Ortigas Center, Pasig City",
    store_email: "#rbg-division11-juliavargas@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "GARNET",
    municipality: "PASIG",
    address:
      "Unit 102, Prestige Tower, Emerald Ave., Ortigas Center, Pasig City",
    store_email: "#rbg-division11-ortigas-garnet@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "PASIG - VALLE VERDE",
    municipality: "PASIG",
    address:
      "Unit SC-112 Silver City 1 Building, Ortigas East, Barangay Ugong, Pasig City",
    store_email: "#rbg-division11-silvercity@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "PASIG - ROSARIO",
    municipality: "PASIG",
    address: "Unit 3, 1866 Ortigas Ave., Ext., Rosario, Pasig City",
    store_email: "#RBG-Division11-Pasig-Rosario@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "PASIG - SANTOLAN",
    municipality: "PASIG",
    address:
      "G/F Santolan Bldg., 344 A. Rodriguez Avenue, Santolan, Pasig City",
    store_email: "#rbg-division11-pasig-santolan@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "PATEROS",
    municipality: "PATEROS",
    address: "M. Almeda corner G. De Borja Street, San Roque, Pateros",
    store_email: "#rbg-division11-pateros@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "ORTIGAS - ADB AVENUE",
    municipality: "PASIG",
    address:
      "G/F, Units G1 & G2, ADB Avenue Tower, ADB Avenue, Ortigas Center, Pasig City",
    store_email: "#rbg-division11-ortigas-adbavenue@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "ORTIGAS - ORIENT SQUARE",
    municipality: "PASIG",
    address:
      "G/F Orient Square Building, Emerald Ave., Ortigas Center Pasig City",
    store_email: "#rbg-division11-ortigas-orientsquare@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "MANDALUYONG - SHAW BLVD",
    municipality: "MANDALUYONG",
    address:
      "G/F, Unit No. 7, Sunshine Square, Liberty Center, Shaw Blvd., Mandaluyong City",
    store_email: "#RBG-Division12-Mandaluyong@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "ANNAPOLIS",
    municipality: "SAN JUAN",
    address:
      "G/F, The Meriden Condominium Building Unit 1A, Annapolis St. NorthEast, Greenhills San Juan City",
    store_email: "#RBG-Division12-Annapolis@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "GREENHILLS - WEST",
    municipality: "SAN JUAN",
    address: "G/F ALCCO Bldg. Ortigas Avenue Greenhills-West, San Juan City",
    store_email: "#RBG-Division12-Greenhills-West@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "SAN JUAN",
    municipality: "SAN JUAN",
    address:
      "EastWest Bank Bldg. F. Blumentritt , corner M. Salvador, Barangay San Perfecto San Juan City",
    store_email: "#RBG-Division12-SanJuan@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "PIONEER",
    municipality: "MANDALUYONG",
    address:
      "UG-09 Pioneer Pointe Condominium Pioneer St. Highway Hills Mandaluyong City",
    store_email: "#RBG-Division12-Pioneer@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "MANDALUYONG - LIBERTAD",
    municipality: "MANDALUYONG",
    address:
      "G/F-Units A,B & C, Dr. Aguilar Bldg. No 46 D.M. Guevarra St., cor Esteban St. Highway Hills Mandaluyong City",
    store_email: "#RBG-Division12-MandaluyongLibertad@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "GREENHILLS SHOPPING CENTER",
    municipality: "SAN JUAN",
    address:
      "Units G-102B, Greenlanes Arcade., Greenhills Shopping Center, San Juan City",
    store_email: "#RBG-Division12-GreenhillsShoppingCenter@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "WILSON",
    municipality: "SAN JUAN",
    address: "No. 220–B Wilson St., San Juan City",
    store_email: "#RBG-Division12-Wilson@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "GREENHILLS - CONNECTICUT",
    municipality: "SAN JUAN",
    address:
      "Unit B, G/F Fox Square Building No. 53 Connecticut Street, Northeast Greenhills San Juan City",
    store_email: "#RBG-Division12-Connecticut@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "BONI AVENUE",
    municipality: "MANDALUYONG",
    address:
      "G/F Lourdes Bldg. II 667 Boni Ave. Bgy. PlainView Mandaluyong City",
    store_email: "#RBG-Division12-BoniAvenue@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "GREENHILLS - NORTH",
    municipality: "SAN JUAN",
    address:
      "G/F BTTC Bldg., Ortigas Ave. cor. Roosevelt St., Greenhills, San Juan City",
    store_email: "#RBG-Division12-Greenhills-North@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "MANDALUYONG – WACK-WACK",
    municipality: "MANDALUYONG",
    address:
      "G/F , Unit JI-E, Jovan Condominium, Shaw Blvd. corner Samat St., Madaluyong City",
    store_email: "#RBG-Division12-Mandaluyong?Wack-Wack@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "KALENTONG",
    municipality: "MANDALUYONG",
    address: "No. 908 Gen. Kalentong Street, Mandaluyong City",
    store_email: "#RBG-Division12-Kalentong@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "GREENHILLS - PROMENADE",
    municipality: "SAN JUAN",
    address:
      "Unit 3, g/f & 2/f Promenade Building, Missouri Street, Greenhills, San Juan City",
    store_email: "#RBG-Division12-Greenhills-Promenade@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "LAS PIÑAS",
    municipality: "LAS PIÑAS",
    address: "Lot 16B PSD 208390 Alabang Zapote Road Las Piñas City",
    store_email: "#RBG-Division15-LasPinas@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "WESTGATE",
    municipality: "MUNTINLUPA",
    address:
      "Westgate, Filinvest Corporate City,  Alabang Muntinlupa City 1770",
    store_email: "#RBG-Division14-Westgate@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "ALABANG - MADRIGAL BUSINESS PARK",
    municipality: "MUNTINLUPA",
    address:
      "G/F CTP Alpha Bldg. Investment Drive Madrigal Business Park, Ayala Alabang, Muntinlupa City",
    store_email: "#RBG-Division14-AlabangMadrigal@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "MUNTINLUPA",
    municipality: "LAS PIÑAS",
    address:
      "G/F Remenes Center Building, No. 22 National Highway, Putatan, Muntinlupa City 1772",
    store_email: "#RBG-Division14-Muntinlupa@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "LAS PIÑAS - BF RESORT",
    municipality: "LAS PIÑAS",
    address:
      "B.F. Resort Drive, Phase IV, BF Resort Village, Las Pinas City 1740",
    store_email: "#RBG-Division14-LasPinasBFResort@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "ALABANG - COMMERCE AVE.",
    municipality: "MUNTINLUPA",
    address:
      "Spectrum Center Block 28, Commerce Ave cor Filinvest Ave., Filinvest City, Alabang, Muntinlupa City",
    store_email: "#RBG-Division14-Alabang-CommerceAve@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "LAS PIÑAS - MARCOS ALVAREZ AVENUE",
    municipality: "LAS PIÑAS",
    address: "No. 575 Marcos Alvarez Ave., Talon V, Las Pinas",
    store_email: "#RBG-Division15-LasPinas-MarcosAlvarezAve@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "ALABANG - ENTRATA",
    municipality: "MUNTINLUPA",
    address:
      "Unit G3 & G4 Entrata, Filinvest Corporate City, Alabang, Muntinlupa City",
    store_email: "#RBG-Division14-Alabang-Entrata@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "LAS PIÑAS - ALMANZA",
    municipality: "LAS PIÑAS",
    address:
      "Aurora Arcade Bldg., Alabang Zapote Road, Almanza Uno, Las Pinas City",
    store_email: "#RBG-Division14-LasPinas-Almanza@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "ALABANG HILLS",
    municipality: "MUNTINLUPA",
    address: "Don Gesu Bldg., Don Jesus Blvd., Brgy. Cupang, Muntinlupa City",
    store_email: "#RBG-Division14-AlabangHills@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "LAS PIÑAS - J. AGUILAR AVE.",
    municipality: "LAS PIÑAS",
    address:
      "J.Aguilar Avenue corner Casimiro Drive, Brgy. BF International, Las Piñas City, Metro Manila",
    store_email: "#RBG-Division14-LasPinas-J.AguilarAve@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "ALABANG - FRABELLE",
    municipality: "MUNTINLUPA",
    address:
      "Frabelle Alabang Bldg. 1100 Madrigal Business Park Alabang Zapote Rd Alabang Muntinlupa City",
    store_email: "#RBG-Division14-Alabang-Frabelle@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "FESTIVAL MALL - EXPANSION WING",
    municipality: "MUNTINLUPA",
    address:
      "Space No. 2219.1, FSM Expansion Mall, Inc., FCC, Alabang-Zapote Road, Muntinlupa City",
    store_email: "#RBG-Division14-FSM3-ExpansionWing@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "FESTIVAL MALL LEVEL 2",
    municipality: "MUNTINLUPA",
    address:
      "Level 2, Unit 2115 - 2118, Festival Supermall Filinvest Corporate City, Alabang Muntinlupa City 1781",
    store_email: "#RBG-Division14-FestivalMall1@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "FESTIVAL MALL LEVEL 1",
    municipality: "MUNTINLUPA",
    address:
      "X-cite Area, Level 1, Festival Supermall, Filinvest Corp. City, Alabang Muntinlupa City 1781",
    store_email: "#RBG-Division14-FestivalMall2@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "BETTER LIVING - DOÑA SOLEDAD AVENUE",
    municipality: "PARAÑAQUE",
    address:
      "No. 100 Dona Soledad Avenue,  Betterliving Subd.Barangay Don Bosco, Paranaque City 1711",
    store_email: "#rbg-division15-betterliving@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "PRESIDENT'S AVENUE",
    municipality: "PARAÑAQUE",
    address:
      "Ground Flr., Johver Bldg., #35 President's Avenue, BF Homes, Parañaque City",
    store_email: "#rbg-division15-president'savenue@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "NINOY AQUINO AVE. - MIESCOR DRIVE",
    municipality: "PARAÑAQUE",
    address:
      "Unit 707-6 Columbia AirFreight Complex, Miescor Drive, Ninoy Aquino Ave. Brgy. Sto. Niño Paranaque City 1700 ",
    store_email: "#rbg-division15-sucat@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "WEST SERVICE ROAD",
    municipality: "PARAÑAQUE",
    address:
      "West Service Road corner Sampaguita Avenue UPS IV Subd., Paranaque City 1700",
    store_email: "#rbg-division15-westserviceroad@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "SUCAT - EVACOM",
    municipality: "PARAÑAQUE",
    address:
      "8208 Dr. A. Santos Avenue Barangay San Isidro, Paranaque City 1700",
    store_email: "#rbg-division15-sucat-evacom@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "BETTER LIVING - PERU",
    municipality: "PARAÑAQUE",
    address:
      "Blk 9, Lot 3 Dona Soledad Ave. cor. Peru St., BetterLiving, Paranaque City",
    store_email:
      "#rbg-division15-betterliving-donasoledadave_@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "SUCAT - KINGSLAND",
    municipality: "PARAÑAQUE",
    address:
      "G/F and 2/F, No. 5 & 6, Kingsland Building, Dr. A. Santos Avenue, Sucat, Paranaque City",
    store_email: "#rbg-division15-sucatkingsland@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "BF HOMES - AGUIRRE",
    municipality: "PARAÑAQUE",
    address: "No. 327 Aguirre Avenue, BF Homes, Paranaque City",
    store_email: "#rbg-division15-bfhomes-aguirreave@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "SUCAT - KABIHASNAN",
    municipality: "PARAÑAQUE",
    address:
      "G/F Unit 3 & 4 Perry Logistics Center Building, Ninoy Aquino Avenue, Paranaque City",
    store_email: "#rbg-division15-sucat-kabihasnan@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "BICUTAN - EAST SERVICE ROAD",
    municipality: "PARAÑAQUE",
    address:
      "G/F, Waltermart Bicutan, East Service Rd., cor. Mañalac Ave., Brgy. San Martin de Porres, Parañaque City",
    store_email: "#rbg-division15-bicutan-eastserviceroad@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "MIA ROAD",
    municipality: "PARAÑAQUE",
    address: "Salud-Dizon Building 1, No. 5 MIA Road, Tambo, Parañaque City",
    store_email: "#rbg-division15-miaroad@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "BAGUMBAYAN",
    municipality: "QUEZON CITY",
    address: "184-B E. Rodriguez, Jr. Avenue, Bagumbayan, Libis, Quezon City",
    store_email: "#RBG-Division16-Bagumbayan@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "KATIPUNAN",
    municipality: "QUEZON CITY",
    address: "No. 132 Katipunan Ave., St. Ignatius Village, Quezon city",
    store_email: "#RBG-Division16-Katipunan@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "MARIKINA - GIL FERNANDO AVE.",
    municipality: "MARIKINA",
    address:
      "Gil Fernando Ave. cor. Estrador St., Midtown Phase 1, San Roque, Marikina City",
    store_email: "#RBG-Division16-Marikina-GilFernandoAve@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "ACROPOLIS",
    municipality: "QUEZON CITY",
    address:
      "Unit 1B G/F Richmond Centre Building, Lot 46, Block 11, E. Rodriguez Jr. Avenue, Brgy. Bagumbayan, Acropolis, Quezon City",
    store_email: "#RBG-Division16-Acropolis@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "MARIKINA - CONCEPCION",
    municipality: "MARIKINA",
    address: "Bayan- Bayanan Ave.,Concepcion, Marikina City",
    store_email: "#RBG-Division16-Marikina-Concepcion@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "EASTWOOD CITY",
    municipality: "QUEZON CITY",
    address:
      "Unit D, Technoplaza One Building, Eastwood City Cyberpark, No. 188 E.Rodriguez Jr. Ave., Bagumbayan, Quezon City",
    store_email: "#RBG-Division16-EastwoodCity@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "MARIKINA - J.P. RIZAL",
    municipality: "MARIKINA",
    address: "No. 367 J.P.Rizal St., Sta.Elena, Marikina City",
    store_email: "#RBG-Division16-Marikina-JPRizal@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "MARIKINA - PARANG",
    municipality: "MARIKINA",
    address: "JNJ Bldg., No. 108 BG Molina St., Parang, Marikina",
    store_email: "#RBG-Division16-Marikina-Parang@eastwestbanker.com",
  },
  {
    location: "NCR",
    store_name: "CHINESE GENERAL HOSPITAL STORE-LITE",
    municipality: "MANILA CITY",
    address:
      "Chinese General Hospital and Medical Center, 286 Blumentritt St., Sta. Cruz, Manila.",
    store_email: "#RBG-Division9-Blumentritt-RizalAve@eastwestbanker.com",
  },
  {
    location: "North Luzon",
    store_name: "DAGUPAN - PEREZ",
    municipality: "DAGUPAN",
    address:
      "Lot 194 D1-A & Lot 194 D1-B, Brgy. Pogo Chico, Perez  Blvd, Dagupan City",
    store_email: "#RBG-Division22-Dagupan-Perez@eastwestbanker.com",
  },
  {
    location: "North Luzon",
    store_name: "LAOAG CITY",
    municipality: "LAOAG",
    address:
      "G/F Puregolds Bldg., Commercial Unit No. 3 & 4 Nolasco St., cor Castro Ave., and J.P. Pizal, Laoag City",
    store_email: "#RBG-Division22-Laoag City@eastwestbanker.com",
  },
  {
    location: "North Luzon",
    store_name: "LA UNION - SAN FERNANDO CITY",
    municipality: "LA UNION",
    address: "Kenny Plaza, Brgy. Catbangen, Quezon Ave. San Fernando La Union",
    store_email: "#RBG-Division22-La Union-San Fernando@eastwestbanker.com",
  },
  {
    location: "North Luzon",
    store_name: "URDANETA CITY",
    municipality: "URDANETA",
    address: "S&P Bldg., Mc Arthur Highway, Nancayasan, Urdaneta City",
    store_email: "#RBG-Division22-Urdaneta City@eastwestbanker.com",
  },
  {
    location: "North Luzon",
    store_name: "PANGASINAN - SAN CARLOS",
    municipality: "PANGASINAN",
    address: "Palaris St. cor. Jaycees St., San Carlos, Pangasinan",
    store_email: "#RBG-Division22-Pangasinan-San Carlos@eastwestbanker.com",
  },
  {
    location: "North Luzon",
    store_name: "ILOCOS SUR - CANDON",
    municipality: "ILOCOS SUR",
    address: "G/F KAMSU Building Brgy San Jose, Candon City, Ilocos Sur",
    store_email: "#RBG-Division22-Ilocos Sur-Candon@eastwestbanker.com",
  },
  {
    location: "North Luzon",
    store_name: "PANGASINAN - ROSALES",
    municipality: "PANGASINAN",
    address:
      "Estrella Compound, Carmen East Rosales, Mac Arthur Highway Pangasinan.",
    store_email: "#RBG-Division22-Pangasinan-Rosales@eastwestbanker.com",
  },
  {
    location: "North Luzon",
    store_name: "DAGUPAN - A.B. FERNANDEZ AVENUE",
    municipality: "DAGUPAN",
    address: "New Star Bldg. A.B Fernandez Avenue. Dagupan City.",
    store_email: "#RBG-Division22-Dagupan-A.B. Fernandez@eastwestbanker.com",
  },
  {
    location: "North Luzon",
    store_name: "VIGAN",
    municipality: "VIGAN",
    address: "Quezon Ave., Vigan City Ilocos Sur",
    store_email: "#RBG-Division22-Vigan@eastwestbanker.com",
  },
  {
    location: "North Luzon",
    store_name: "PANGASINAN - LINGAYEN",
    municipality: "PANGASINAN",
    address: "Avenida Rizal East Road, Lingayen, Pangasinan",
    store_email: "#RBG-Division22-Pangasinan-Lingayen@eastwestbanker.com",
  },
  {
    location: "North Luzon",
    store_name: "LA UNION - AGOO",
    municipality: "LA UNION",
    address: "Mac Arthur Highway, Barangay San Antonio, Agoo, La Union",
    store_email: "#RBG-Division22-La Union-Agoo@eastwestbanker.com",
  },
  {
    location: "North Luzon",
    store_name: "ILOCOS NORTE - SAN NICOLAS",
    municipality: "ILOCOS NORTE",
    address: "Barangay 2, San Nicolas, Ilocos Norte",
    store_email: "#RBG-Division22-Ilocos Norte-San Nicolas@eastwestbanker.com",
  },
  {
    location: "North Luzon",
    store_name: "PANGASINAN - MANGALDAN",
    municipality: "PANGASINAN",
    address:
      "Cadastral Lot No. 335 Rizal Ave., Brgy. Poblacion, Mangaldan, Pangasinan",
    store_email: "#RBG-Division22-Pangasinan Mangaldan@eastwestbanker.com",
  },
  {
    location: "North Luzon",
    store_name: "PANGASINAN - ALAMINOS",
    municipality: "PANGASINAN",
    address:
      "BHF Blue Horizon Bldg., Quezon Ave., Poblacion , Alaminos City, Pangasinan",
    store_email: "#RBG-Division22-Pangasinan-Alaminos@eastwestbanker.com",
  },
  {
    location: "North Luzon",
    store_name: "ISABELA - SANTIAGO",
    municipality: "ISABELA",
    address:
      "Midori Bldg, National Highway, Villasis, Santiago City, Isabela 3311",
    store_email: "#RBG-Division19-Isabela-Santiago@eastwestbanker.com",
  },
  {
    location: "North Luzon",
    store_name: "ISABELA - CAUAYAN",
    municipality: "ISABELA",
    address: "Maharlika Highway Cauayan City, Isabela",
    store_email: "#RBG-Division19-Isabela-Cauayan@eastwestbanker.com",
  },
  {
    location: "North Luzon",
    store_name: "TUGUEGARAO CITY",
    municipality: "TUGUEGARAO",
    address:
      "College Ave. cor Rizal and Bonifacio St., Brgy. 08, Poblacion, Tuguegarao City",
    store_email: "#RBG-Division19-TuguegaraCity@eastwestbanker.com",
  },
  {
    location: "North Luzon",
    store_name: "NUEVA VIZCAYA - SOLANO",
    municipality: "NUEVA VIZCAYA",
    address: "Maharlika Road, Poblacion, Solano, Nueva Vizcaya",
    store_email: "#RBG-Division19-NuevaVizcaya-Solano@eastwestbanker.com",
  },
  {
    location: "North Luzon",
    store_name: "ISABELA - ILAGAN",
    municipality: "ISABELA",
    address:
      "Maharlika Highway corner Florencio Apostol Street, Calamagui 1, Ilagan, Isabela",
    store_email: "#RBG-Division19-Isabela-Ilagan@eastwestbanker.com",
  },
  {
    location: "North Luzon",
    store_name: "ISABELA - ROXAS",
    municipality: "ISABELA",
    address: "Maharlika Hi-way Brgy. Bantug Roxas Isabela 3320",
    store_email: "#RBG-Division21-Isabela-Roxas@eastwestbanker.com",
  },
  {
    location: "Central Luzon",
    store_name: "SAN FERNANDO - DOLORES",
    municipality: "SAN FERNANDO",
    address:
      "Felix S. David Bdg., MacArthur Highway, Dolores, San Fernando City, Pampanga",
    store_email: "#RBG-Division20-SanFernando-Dolores@eastwestbanker.com",
  },
  {
    location: "Central Luzon",
    store_name: "PAMPANGA - ANGELES CITY",
    municipality: "PAMPANGA",
    address:
      "Unit 4-7 AYA Bldg. Sto. Rosario Street, Brgy. San Jose, Angeles City, Pampanga           ",
    store_email: "#RBG-Division20-AngelesPampanga@eastwestbanker.com",
  },
  {
    location: "Central Luzon",
    store_name: "TARLAC - F. TAÑEDO",
    municipality: "TARLAC",
    address: "Mariposa Bldg.,F. Tanedo St., Tarlac City",
    store_email: "#RBG-Division20-Tarlac-F.Tanedo@eastwestbanker.com",
  },
  {
    location: "Central Luzon",
    store_name: "OLONGAPO CITY",
    municipality: "OLONGAPO",
    address: "No. 1215 Rizal Ave., West Tapinac, Olongapo City",
    store_email: "#RBG-Division20-OlongapoCity@eastwestbanker.com",
  },
  {
    location: "Central Luzon",
    store_name: "BATAAN - BALANGA",
    municipality: "BATAAN",
    address:
      "Don Manuel Banzon Ave. Cor. Cuaderno St. Dona Fransica Balanga City, Bataan",
    store_email: "#RBG-Division20-BalangaBataan@eastwestbanker.com",
  },
  {
    location: "Central Luzon",
    store_name: "PAMPANGA - APALIT",
    municipality: "PAMPANGA",
    address: "Bgy. San Vicente, Apailt, Pampanga",
    store_email: "#RBG-Division20-Pampanga-Apalit@eastwestbanker.com",
  },
  {
    location: "Central Luzon",
    store_name: "ANGELES - BALIBAGO",
    municipality: "PAMPANGA",
    address: "Saver's Mall Bldg. Mac Arthur Highway, Balibago Angeles City",
    store_email: "#RBG-Division20-Angeles-Balibago@eastwestbanker.com",
  },
  {
    location: "Central Luzon",
    store_name: "SAN FERNANDO - SINDALAN",
    municipality: "PAMPANGA",
    address:
      "T & M Building, Mac Arthur Highway, Brgy. Sindalan, San Fernando, Pampanga",
    store_email: "#RBG-Division20-SanFernandoSindalan@eastwestbanker.com",
  },
  {
    location: "Central Luzon",
    store_name: "BATAAN - DINALUPIHAN",
    municipality: "BATAAN",
    address: "Bgy. San Ramon, Dinalupihan, Bataan",
    store_email: "#RBG-Division20-Bataan-Dinalupihan@eastwestbanker.com",
  },
  {
    location: "Central Luzon",
    store_name: "PAMPANGA - GUAGUA",
    municipality: "PAMPANGA",
    address:
      "Goodluck Bldg., No. 303 Guagua-Sta. Rita Arterial Road, Brgy. San Roque, Guagua, Pampanga",
    store_email: "#RBG-Division20-Pampanga-Guagua@eastwestbanker.com",
  },
  {
    location: "Central Luzon",
    store_name: "TARLAC - PANIQUI",
    municipality: "TARLAC",
    address:
      "No. 130 M.H. Del Pilar St., cor. Mac Arthur Highway, Paniqui, Tarlac City",
    store_email: "#RBG-Division20-TarlacPaniqui@eastwestbanker.com",
  },
  {
    location: "Central Luzon",
    store_name: "SUBIC BAY",
    municipality: "OLONGAPO",
    address: "No. 1109 Rizal Highway, Subic Bay Freeport Zone, Olongapo City",
    store_email: "#RBG-Division20-SubicBay@eastwestbanker.com",
  },
  {
    location: "Central Luzon",
    store_name: "SAN FERNANDO - JOSE ABAD SANTOS",
    municipality: "PAMPANGA",
    address:
      "G/F, Units 1A &1B Kingsborough Commercial Center Building, Jose Abad Santos Avenue, San Fernando, Pampanga 2000",
    store_email: "#RBG-Division20-SanFernando-JASA@eastwestbanker.com",
  },
  {
    location: "Central Luzon",
    store_name: "ZAMBALES - IBA",
    municipality: "ZAMBALES",
    address:
      "Lot No. 1-A, Zambales - Pangasinan Provincial Road, Brgy. Sagapan, Iba, Zambales",
    store_email: "#RBG-Division20-Zambales-Iba@eastwestbanker.com",
  },
  {
    location: "Central Luzon",
    store_name: "BATAAN - MARIVELES",
    municipality: "BATAAN",
    address: "8th Avenue, Freeport Area of Bataan (FAB), Mariveles, Bataan",
    store_email: "#RBG-Division20-Bataan-Mariveles@eastwestbanker.com",
  },
  {
    location: "Central Luzon",
    store_name: "TARLAC - CONCEPCION",
    municipality: "TARLAC",
    address:
      "Lot No. 1889, B1,B2,B3, L. Cortez St., San Nicolas, Concepcion, Tarlac",
    store_email: "#RBG-Division20-Tarlac-Concepcion@eastwestbanker.com",
  },
  {
    location: "Central Luzon",
    store_name: "TARLAC - MCARTHUR HIGHWAY",
    municipality: "TARLAC",
    address:
      "Lot No. 27 Block 17, McArthur Highway corner Calle Manuel, San Sebastian Village, Tarlac, Tarlac",
    store_email: "#RBG-Division20-Tarlac-McArthurHighway@eastwestbanker.com",
  },
  {
    location: "Central Luzon",
    store_name: "PAMPANGA - CLARK",
    municipality: "PAMPANGA",
    address:
      "Pavilion 16 Berthaphil Clark Center, Jose Abad Santos ave., TFZ Clark SPCL Ecozone, Angeles City, Pampanga",
    store_email: "#RBG-Division20-Pampanga-Clark@eastwestbanker.com",
  },
  {
    location: "Central Luzon",
    store_name: "CABANATUAN - MELENCIO",
    municipality: "CABANATUAN",
    address: "Melencio St. corner Gen. Luna ST, Cabanatuan City",
    store_email: "#RBG-Division19-Cabanatuan-Melencio@eastwestbanker.com",
  },
  {
    location: "Central Luzon",
    store_name: "BALIUAG",
    municipality: "BULACAN",
    address:
      "Doña Remedios Trinidad Highway corner Benigno S. Aquino Ave., Baliuag, Bulacan",
    store_email: "#RBG-Division19-Baliuag@eastwestbanker.com",
  },
  {
    location: "Central Luzon",
    store_name: "MEYCAUAYAN - MALHACAN",
    municipality: "BULACAN",
    address: "Meycauayan Tollgate, Meaycauayan City, Bulacan",
    store_email: "#RBG-Division18-Meycauayan-Malhacan@eastwestbanker.com",
  },
  {
    location: "Central Luzon",
    store_name: "NUEVA ECIJA - SAN JOSE",
    municipality: "NUEVA ECIJA",
    address:
      "Paulino Building, Brgy. Abar 1st Maharlika Road, San Jose Nueva Ecija",
    store_email: "#RBG-Division19-NuevaEcija-SanJose@eastwestbanker.com",
  },
  {
    location: "Central Luzon",
    store_name: "BULACAN - PLARIDEL",
    municipality: "BULACAN",
    address:
      "Lot 1071- A, Daang Maharlika Road, (Prev. Cagayan Valley Road) Banga First, Plaridel Bualacan",
    store_email: "#RBG-Division19-Bulacan-Plaridel@eastwestbanker.com",
  },
  {
    location: "Central Luzon",
    store_name: "NUEVA ECIJA - GAPAN",
    municipality: "NUEVA ECIJA",
    address: "TSI Bldg., Jose abad Santos Ave., Sto. Niño, Gapan, Nueva Ecija",
    store_email: "#RBG-Division19-NuevaEcija-Gapan@eastwestbanker.com",
  },
  {
    location: "Central Luzon",
    store_name: "BULACAN - BALAGTAS",
    municipality: "BULACAN",
    address: "Burol 1st, Mc Arthur Highway, Balagtas Bulacan",
    store_email: "#RBG-Division18-Bulacan-Balagtas@eastwestbanker.com",
  },
  {
    location: "Central Luzon",
    store_name: "MALOLOS",
    municipality: "BULACAN",
    address:
      "G/F, BUFECO Bldg., No. 1197 Brgy. Sumapang Matanda, Mac Arthur Highway Malolos, Bulacan",
    store_email: "#RBG-Division18-Malolos@eastwestbanker.com",
  },
  {
    location: "Central Luzon",
    store_name: "NUEVA ECIJA - TALAVERA",
    municipality: "NUEVA ECIJA",
    address: "Lot No. 269–A Maharlika Road, Poblacion, Talavera, Nueva Ecija",
    store_email: "#RBG-Division19-NuevaEcija-Talavera@eastwestbanker.com",
  },
  {
    location: "Central Luzon",
    store_name: "BULACAN - SAN JOSE DEL MONTE",
    municipality: "BULACAN",
    address:
      "Dalisay Resort, Gov. F. Halili Avenue, Tungkong Mangga, San Jose del Monte, Bulacan",
    store_email: "#RBG-Division19-Bulacan-SanJoseDelMonte@eastwestbanker.com",
  },
  {
    location: "Central Luzon",
    store_name: "CABANATUAN - MAHARLIKA",
    municipality: "CABANATUAN",
    address: "Maharlika Highway, Brgy. Dicarma, Cabanatuan City, Nueva Ecija",
    store_email: "#RBG-Division21-Cabanatuan?Maharlika@eastwestbanker.com",
  },
  {
    location: "Central Luzon",
    store_name: "BULACAN - STA. MARIA",
    municipality: "BULACAN",
    address: "No. 115 M. De Leon St., Brgy., Poblacion, Sta. Maria, Bulacan",
    store_email: "#RBG-Division19-Bulacan-Sta.Maria@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "TAYTAY",
    municipality: "RIZAL",
    address: "Vallley Fait Town Center, Ortigas Ave., Extension, Taytay, Rizal",
    store_email: "#RBG-Division16-Taytay-ManilaEast@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "ANTIPOLO - MARCOS HIGHWAY",
    municipality: "RIZAL",
    address: "Ciannat Complex, Marcos Highway Brgy. Mayamot, Antipolo City",
    store_email: "#RBG-Division16-MarcosHighway@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "ANTIPOLO - M.L. QUEZON AVE.",
    municipality: "RIZAL",
    address:
      "No. 146 M.L.quezon Ave., cor. F. Dimanlig St., San Roque, Antipolo City",
    store_email: "#RBG-Division16-Antipolo-M.L.Quezon@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "TAYTAY - MANILA EAST",
    municipality: "RIZAL",
    address: "Manila East Road, Brgy. San Juan, Taytay Rizal",
    store_email: "#RBG-Division16-Taytay-ManilaEast@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "MONTALBAN - RIZAL",
    municipality: "RIZAL",
    address: "No. 240 E. Rodriguez Hi-way, Manggahan, Rodriguez, Rizal",
    store_email: "#RBG-Division16-Montalban-Rizal@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "RIZAL - SAN MATEO",
    municipality: "RIZAL",
    address: "Lot 551-A-8 Gen. Luna St., Brgy. Ampid, San Mateo, Rizal ",
    store_email: "#RBG-Division16-SanMateo@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "IMUS",
    municipality: "CAVITE",
    address: "G/F, LDB Bldg., 552 Gen. Aguinaldo Highway, Imus City, Cavite",
    store_email: "pbc_imus@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "BACOOR - AGUINALDO HIGHWAY",
    municipality: "CAVITE",
    address: "General E. Aguinaldo Highway Talaba Bacoor City Cavite",
    store_email: "pbc_bacoor@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "CARMONA",
    municipality: "CAVITE",
    address:
      "Lot 1947-B, Paseo de Carmona Compound, Governor’s Drive, Brgy. Maduya, Carmona, Cavite ",
    store_email: "pbc_carmona@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "GENERAL TRIAS",
    municipality: "CAVITE",
    address:
      "G/F, Unit 102 VCentral Gentri Bldg., Governor’s Drive, Manggahan, General Trias, Cavite",
    store_email: "#RBG-Division15-GeneralTrias@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "BACOOR - MOLINO",
    municipality: "CAVITE",
    address:
      "G/F Units 101, 102 & 103 VCENTRAL Mall Molino Bldg., Molino Blvd., Bacoor City, Cavite",
    store_email: "#RBG-Division15-Bacoor-Molino@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "CAVITE - NAIC",
    municipality: "CAVITE",
    address: "Ibayo Silangan cor. Daang Sabang Road, Naic Cavite",
    store_email: "#RBG-Division15-Cavite-Naic@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "CAVITE - TANZA",
    municipality: "CAVITE",
    address: "Antero Soriano Highway, Daang Amaya 2, Tanza, Cavite",
    store_email: "#RBG-Division15-Cavite-Tanza@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "DASMARIÑAS",
    municipality: "CAVITE",
    address:
      "Km. 31 Gen. Emilio Aguinaldo Highway, Brgy. Zone 4, Dasmariñas City, Cavite",
    store_email: "#RBG-Division15-Dasmarinas@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "CAVITE CITY",
    municipality: "CAVITE",
    address: "P. Burgos Ave., Brgy. Caridad, Cavite City",
    store_email: "#RBG-Division15-CaviteCity@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "CAVITE - TRECE MARTIRES",
    municipality: "CAVITE",
    address:
      "g/f Dionets Commercial Place Building,Trece Martires-Indang Road, Brgy. San Agustin, Trece Martires City, Cavite",
    store_email: "#RBG-Division15-Cavite-TreceMartires@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "CAVITE - SILANG",
    municipality: "CAVITE",
    address:
      "No. 132 J. P Rizal Street, corner E. Montoya Street, Brgy. San Vicente I, Silang, Cavite",
    store_email: "#RBG-Division15-Cavite-Silang@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "KAWIT - CENTENNIAL",
    municipality: "CAVITE",
    address: "Centennial Road, Tabon 1, Kawit, Cavite",
    store_email: "#RBG-Division17-Kawit-Centennial@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "CAVITE - ROSARIO",
    municipality: "CAVITE",
    address: "Lot 616 F1 Gen. Trias Drive, Tejeros Convention Rosario, Cavite",
    store_email: "#RBG-Division17-CaviteRosario@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "TAGAYTAY",
    municipality: "CAVITE",
    address:
      "G/F, Unit 1001.1, Fora Mall, Emilio Aguinaldo Highway, Brgy. Crossing East, Rotunda, Tagaytay City, Cavite   ",
    store_email: "#RBG-Division17-Tagaytay@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "LUCENA CITY",
    municipality: "QUEZON PROV.",
    address:
      "Quezon Avenue corner Rosas Street, Barangay 8, Lucena City, Quezon",
    store_email: "pbc_lucena@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "BATANGAS CITY",
    municipality: "BATANGAS",
    address:
      "54-A D. Silang St. cor. Pastor St., Brgy. 14 Poblacion, Batangas City",
    store_email: "pbc_batangas@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "LIPA CITY",
    municipality: "BATANGAS",
    address: "Brgy. Balintawak Lipa Ayala Hi-way Lipa City, Batangas",
    store_email: "pbc_lipa@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "BATANGAS - BAUAN",
    municipality: "BATANGAS",
    address: "J.P. Rizal Street corner San Agustin Street, Bauan, Batangas",
    store_email: "#RBG-Division18-Batangas-Bauan@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "BATANGAS - TANAUAN",
    municipality: "BATANGAS",
    address: "No. 98 J.P. Laurel Hi-way, Brgy. Darasa,Tanauan City",
    store_email: "#RBG-Division18-Batangas-Tanauan@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "BATANGAS - LEMERY",
    municipality: "BATANGAS",
    address: "g/f LDMC Building, Ilustre Ave. Brgy. Rizal, Lemery, Batangas",
    store_email: "#RBG-Division18-Batangas-Lemery@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "BATANGAS - ROSARIO",
    municipality: "BATANGAS",
    address: "Rosario-Padre Garcia-Lipa Road, Poblacion Rosario, Batangas",
    store_email: "#RBG-Division18-Batangas-Rosario@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "BATANGAS - NASUGBU",
    municipality: "BATANGAS",
    address: "J. P. Laurel Street, Poblacion, Nasugbu, Batangas",
    store_email: "#RBG-Division18-Batangas-Nasugbu@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "BATANGAS - STO. TOMAS",
    municipality: "BATANGAS",
    address: "KM 67 Maharlika Highway, Poblacion Sto. Tomas, Batangas",
    store_email: "#RBG-Division18-Batangas-Sto.Tomas@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "BATANGAS - BALAYAN",
    municipality: "BATANGAS",
    address: "cor. Paz St. and Union St., Poblacion, Balayan, Batangas",
    store_email: "#RBG-Division18-Batangas-Balayan@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "QUEZON - CANDELARIA",
    municipality: "QUEZON PROV.",
    address:
      "corner National Highway and Ona Street, Brgy. Poblacion Candelaria Quezon",
    store_email: "#RBG-Division18-Candelaria@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "MINDORO - CALAPAN",
    municipality: "ORIENTAL MINDORO",
    address:
      "G/F Paras Bldg., J.P. Rizal St., Bgy. San Vicente South, Calapan, Oriental Mindoro",
    store_email: "#RBG-Division18-Mindoro-Calapan@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "BATANGAS CITY - PALLOCAN",
    municipality: "BATANGAS",
    address:
      "Unit Nos. 6, 7, and 8, Mayvel Center Building, Manuela Pastor Avenue, Brgy. Pallocan West, Batangas City",
    store_email: "#RBG-Division18-BatangasCity-Pallocan@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "CALAMBA",
    municipality: "LAGUNA",
    address: "G/F, SQA Bldg, Brgy. Uno, Crossing, Calamba City, Laguna",
    store_email: "#RBG-Division19-Calamba@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "SAN PABLO",
    municipality: "LAGUNA",
    address:
      "Lots 2365 & 3152, J. P. Rizal Avenue, Poblacion, San Pablo City, Laguna",
    store_email: "#RBG-Division19-SanPablo@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "SAN PEDRO",
    municipality: "LAGUNA",
    address: "National Highway, Brgy. Nueva, San Pedro, Laguna",
    store_email: "#RBG-Division19-SanPedro@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "LAGUNA - CABUYAO",
    municipality: "LAGUNA",
    address: "No. 26 J. P. Rizal Street, Poblacion, Cabuyao City, Laguna",
    store_email: "#RBG-Division19-Laguna-Cabuyao@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "LAGUNA - BIÑAN",
    municipality: "LAGUNA",
    address:
      "G/F, Units 1,2,3 & 4, Simrey's Commercial Building, National Highway corner Alma Manzo Road, Brgy. San Antonio, Biñan City, Laguna",
    store_email: "#RBG-Division19-Laguna-Binan@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "STA. ROSA",
    municipality: "LAGUNA",
    address:
      "Unit No. 6, Paseo 5 - Paseo de Sta Rosa, Greenfield  City, Don Jose, Santa Rosa City, Laguna",
    store_email: "#RBG-Division19-Sta.Rosa@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "CALAMBA - NATIONAL ROAD",
    municipality: "LAGUNA",
    address: "No. 1425 National Road, Brgy. Uno Crossing, Calamba Laguna 4027",
    store_email: "#RBG-Division19-Calamba-NationalRoad@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "LAGUNA - STA. CRUZ",
    municipality: "LAGUNA",
    address:
      "Sun Moon Arcade Building, No. 129 P. Guevara Ave., Poblacion 2 , Sta Cruz, Laguna ",
    store_email: "#RBG-Division19-Laguna-Sta.Cruz@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "PALAWAN",
    municipality: "PALAWAN",
    address: "Rizal Avenue, Brgy. Manggahan, Puerto Princesa City, Palawan",
    store_email: "#RBG-Division27-PuertoPrincesa-RizalAve@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "NAGA CITY",
    municipality: "CAMARINES SUR",
    address:
      "g/f, LAM Bldg., No. 19 Peñafrancia Avenue, Zone 1, Brgy. San Francisco, Naga City, Camarines Sur",
    store_email: "#RBG-Division19-NagaCity@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "LEGAZPI CITY",
    municipality: "ALBAY",
    address: "Block 2 Lot 3-B, Landco Business Park, Legaspi City, Albay",
    store_email: "#RBG-Division19-LegazpiCity@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "SORSOGON",
    municipality: "SORSOGON",
    address:
      "Ma. Bensuat T. Dogillo Bldg., Magsaysay St., Poblacion, Sorsogon City",
    store_email: "#RBG-Division19-SorsogonCity@eastwestbanker.com",
  },
  {
    location: "South Luzon",
    store_name: "TABACO CITY",
    municipality: "ALBAY",
    address: "Manuel Cea Bldg. I, Santillan St., Poblacion, Tabaco City, Albay",
    store_email: "#RBG-Division19-TabacoCity@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "ILOILO - LEDESMA",
    municipality: "ILOILO",
    address:
      "Sta. Cruz Arancillo Bldg. Ledesma corner Fuentes Sts., Iloilo City",
    store_email: "#RBG-Division24-Iloilo@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "ILOILO - IZNART",
    municipality: "ILOILO",
    address: "G/F, B&C Square Bldg., Iznart St. cor. Solis St., Iloilo City",
    store_email: "#RBG-Division24-IloiloIznart@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "ILOILO - MOLO",
    municipality: "ILOILO",
    address: "GT Plaza Mall, MH del Pilar St., Molo, Iloilo City",
    store_email: "#RBG-Division24-Iloilo-Molo@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "BORACAY",
    municipality: "AKLAN",
    address:
      "Alexandrea Bdlg., Main Road Brgy. Balabag Boracay Island, Malay Aklan",
    store_email: "#RBG-Division24-Boracay@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "ILOILO - JARO",
    municipality: "ILOILO",
    address:
      "Jaro Townsquare, Mandaue Foam Building, Quintin Salas, Jaro, Iloilo City",
    store_email: "#RBG-Division24-Iloilo-Jaro@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "ROXAS CITY",
    municipality: "CAPIZ",
    address:
      "Corner Roxas Avenue and Osmeña St. (formerly Pavia St.), Roxas City, Capiz",
    store_email: "#RBG-Division24-RoxasCity@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "KALIBO",
    municipality: "AKLAN",
    address: "Roxas Avenue Extension, Kalibo, Aklan",
    store_email: "#RBG-Division24-Kalibo@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "ANTIQUE - SAN JOSE",
    municipality: "ANTIQUE",
    address: "St. Nicolas Building, T.A. Fornier Street, San Jose, Antique",
    store_email: "#RBG-Division24-Antique-SanJose@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "ILOILO - DIVERSION ROAD",
    municipality: "ILOILO",
    address:
      "The 21 Avenue Building, Benigno Aquino Avenue, Mandurriao, Iloilo City",
    store_email: "#RBG-Division24-Iloilo-Diversion@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "CEBU - N. ESCARIO",
    municipality: "CEBU",
    address:
      "Cebu Capitol Commercial Complex Bldg. N. Escario Street, Cebu City",
    store_email: "#RBG-Division23-Cebu-N.Escario@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "CEBU - MANDAUE BRIONES HIGHWAY",
    municipality: "CEBU",
    address: "Kina Building, National Highway, Subangdaku, Mandaue City, Cebu ",
    store_email: "pbc_cebumandaue@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "CEBU - BANILAD",
    municipality: "CEBU",
    address:
      "G/F Unit 101 of PDI Condominium Gov. M. Cuenco Ave. corner J. Panis St. Banilad, Cebu City",
    store_email: "#RBG-Division23-Cebu-Banilad@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "CEBU - GRAND CENIA",
    municipality: "CEBU",
    address: "Grand Cenia Bldg., Archbishop Reyes Avenue, Cebu City",
    store_email: "#RBG-Division23-Cebu-GrandCenia@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "CEBU - A.S. FORTUNA",
    municipality: "CEBU",
    address: "AYS Bldg., A.S. Fortuna St., Brgy. Banilad, Mandaue City, Cebu",
    store_email: "#RBG-Division23-CebuASFortuna@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "CEBU - M. VELEZ",
    municipality: "CEBU",
    address: "No. 151, M. Velez St., Guadalupe, Cebu City",
    store_email: "#RBG-Division23-CebuMVelez@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "CEBU - PARK MALL",
    municipality: "CEBU",
    address: "Alfresco 4, Units 39, 40 & 40a Parkmall, Mandaue City",
    store_email: "#RBG-Division23-Cebu-ParkMall@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "CEBU - FUENTE OSMEÑA",
    municipality: "CEBU",
    address: "G/F Cebu Women's Club Building Fuente Osmeña, Cebu City",
    store_email: "#RBG-Division23-Cebu-FuenteOsmena@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "CEBU - ASIA TOWN IT PARK",
    municipality: "CEBU",
    address:
      "G/F, Calyx Center, W. Ginonzon Street corner Abad Street, Asia Town, IT Park, Cebu City",
    store_email: "#RBG-Division23-Cebu-AsiaTownITPark@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "CEBU - COLON",
    municipality: "CEBU",
    address:
      "GF Iconique Center, Colon Street, Brgy Kalubihan, Cebu City ( Across Colonnade Mall)",
    store_email: "#RBG-Division23-Cebu-Colon@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "CEBU - MAGALLANES",
    municipality: "CEBU",
    address: "Go Quiaco Bldg. Magallanes cor Gonzales Sts, Cebu City",
    store_email: "#RBG-Division23-CebuMagallanes@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "CEBU - FREEDOM PARK",
    municipality: "CEBU",
    address:
      "CLC Bldg., 280 Magallanes St. near corner Noli Me Tangere, Cebu City",
    store_email:
      "#RBG-Division23-CebuMagallanes-NoliMeTangere@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "CEBU - SRP IL CORSO",
    municipality: "CEBU",
    address: "Unit R 160 & 161 IL Corso Retail Building, SRP Cebu City ",
    store_email: "#RBG-Division23-CebuIlCorso@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "CEBU - MACTAN",
    municipality: "CEBU",
    address:
      "G/F Bldg. II, M. L. Quezon National Highway Pusok, Lapu-lapu City",
    store_email: "#RBG-Division27-CebuMactan@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "CEBU - MANDAUE NORTH ROAD",
    municipality: "CEBU",
    address: "G/F, ALDO Bldg., North Road, Basak, Mandaue City, Cebu",
    store_email: "#RBG-Division27-Cebu-MandaueNorthRoad@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "CEBU - MINGLANILLA",
    municipality: "CEBU",
    address:
      "G/F La Nueva - Minglanilla Center, Ward 2, Poblacion Minglanilla Cebu 6046",
    store_email: "#RBG-Division27-Cebu-Minglanilla@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "CEBU - TALISAY",
    municipality: "CEBU",
    address: "Paul Sy Bldg Highway Tabunok, Talisay City, Cebu",
    store_email: "#RBG-Division27-Cebu-Talisay@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "CEBU - A. C. CORTES",
    municipality: "CEBU",
    address:
      "Carlos Perez Building, A.C. Cortes Avenue, Brgy. Ibabao, Mandaue City, Cebu",
    store_email: "#RBG-Division27-Cebu-ACCortes@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "CEBU - BASAK PARDO",
    municipality: "CEBU",
    address:
      "South Point Place Building, N. Balasco Ave., South Road, Basak Pardo, Cebu City",
    store_email: "#RBG-Division27-Cebu-BasakPardo@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "TAGBILARAN CITY",
    municipality: "LEYTE",
    address: "CPG Avenue, 2nd District, Tagbilaran City",
    store_email: "#RBG-Division27-TagbilaranCity@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "ORMOC CITY",
    municipality: "LEYTE",
    address: "G/F Hotel Don Felipe Annex Bldg. Bonifacio St., Ormoc City",
    store_email: "#RBG-Division27-OrmocCity@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "TACLOBAN CITY - MARASBARAS",
    municipality: "LEYTE",
    address: "G/F, JGC Bldg., Brgy. 77, Marasbaras, Tacloban City",
    store_email: "#RBG-Division27-TaclobanCity-Marasbaras@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "CATBALOGAN",
    municipality: "LEYTE",
    address: "Curry Avenue corner San Bartolome Street, Catbalogan City, Samar",
    store_email: "#RBG-Division27-CatbaloganCity@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "TACLOBAN CITY - J. ROMUALDEZ",
    municipality: "LEYTE",
    address: "RUL Building, Justice Romualdez St., Brgy.15, Tacloban City",
    store_email: "#RBG-Division27-Tacloban-J.Romualdez@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "ZAMBOANGA CITY - N.S. VALDERROSA",
    municipality: "ZAMBOANGA CITY",
    address: "N.S. Valderrosa St. corner Corcuerra St., Zamboanga City",
    store_email: "#RBG-Division26-Zamboanga-NSValderrosa@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "PAGADIAN CITY",
    municipality: "ZAMBOANGA DEL SUR",
    address:
      "BMD Estate Bldg., F. Pajares cor. Sanson St., Pagadian City, Zamboanga del Sur",
    store_email: "#RBG-Division26-PagadianCity@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "ZAMBOANGA CITY - CANELAR",
    municipality: "ZAMBOANGA CITY",
    address:
      "Anchor Block 2-A, L'Arcada Complex, MCLL Highway, Tetuan, Zamboanga City",
    store_email: "#RBG-Division26-Zamboanga-L'Arcada@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "DIPOLOG CITY",
    municipality: "DIPOLOG CITY",
    address: "G/F Felicidad II Bldg., Quezon Ave., Miputak, Dipolog City",
    store_email: "#RBG-Division26-DipologCity@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "CAGAYAN DE ORO CITY - VELEZ",
    municipality: "CAGAYAN DE ORO CITY",
    address:
      "Juan Sia Bldg., No. 50  Don Apolinar Velez St. Cagayan de Oro City",
    store_email: "#RBG-Division26-CagayandeOro-Velez@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "ILIGAN CITY",
    municipality: "ILIGAN CITY",
    address: "G/F, Party Plaza Bldg., Quezon Ave. Ext., Rabago, Iligan City",
    store_email: "#RBG-Division26-IliganCity@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "OZAMIZ CITY",
    municipality: "OZAMIZ",
    address: "G/F, Casa Esperanza, Don Anselmo Bernard Ave., Ozamiz City, 7200",
    store_email: "#RBG-Division26-OzamizCity@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "CAGAYAN DE ORO CITY - COGON",
    municipality: "CAGAYAN DE ORO CITY",
    address:
      "De Oro Construction Supply, Inc Bldg., Don Sergio Osmenia St. cor Limketkai Drive Cagayan de Oro City",
    store_email: "#RBG-Division26-CagayandeOro-Cogon@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "CAGAYAN DE ORO - CARMEN",
    municipality: "CAGAYAN DE ORO CITY",
    address: "RTS Bldg., Vamenta Blvd., Carmen, Cagayan de Oro City",
    store_email: "#RBG-Division26-CagayandeOro-Carmen@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "CAGAYAN DE ORO - LAPASAN",
    municipality: "CAGAYAN DE ORO CITY",
    address: "Lapasan Highway, Cagayan de Oro City",
    store_email: "#RBG-Division26-CagayandeOro-Lapasan@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "CAGAYAN DE ORO – PUEBLO DE ORO",
    municipality: "CAGAYAN DE ORO CITY",
    address:
      "VLC Tower One, B1 L1, Gran Via St., Pueblo de Oro, Cagayan de Oro City",
    store_email: "#RBG-Division26-CagayandeOro-PueblodeOro@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "BUKIDNON - VALENCIA",
    municipality: "BUKIDNON",
    address:
      "Tamay Lang Lang Park Lane Bldg., G. La Viña Ave., Poblacion, Valencia City, Bukidnon",
    store_email: "#RBG-Division28-Bukidnon-Valencia@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "DAVAO - LANANG",
    municipality: "DAVAO",
    address: "Lot 6, Blk 5, Insular Village, Pampanga, Lanang, Davao City",
    store_email: "#RBG-Division23-Davao-Lanang@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "DAVAO - STA. ANA",
    municipality: "DAVAO",
    address: "g/f, GH Depot Bldg., Gov. Sales St., Sta. Ana, Davao City",
    store_email: "#RBG-Division23-Davao-Sta.Ana@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "DAVAO - MATINA",
    municipality: "DAVAO",
    address: "Lot 16 Blk 3, McArthur Highway, Matina, Davao City",
    store_email: "#RBG-Division23-Davao-Matina@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "DAVAO - TORIL",
    municipality: "DAVAO",
    address: "Saavedra St., Toril, Davao City",
    store_email: "#RBG-Division23-Davao-Toril@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "DAVAO - C.M. RECTO",
    municipality: "DAVAO",
    address: "P&E Building, Poblacion, Brgy. 035 C.M. Recto Avenue, Davao City",
    store_email: "#RBG-Division23-Davao-C.M.Recto@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "DAVAO - BAJADA",
    municipality: "DAVAO",
    address:
      "Carolina Uykimpang Bldg., Corner Iñigo St., J.P. Laurel Avenue Davao City",
    store_email: "#RBG-Division23-Davao-Bajada@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "DAVAO - J.P. LAUREL",
    municipality: "DAVAO",
    address: "JP Laurel Avenue, Davao City",
    store_email: "#RBG-Division23-Davao-J.P.Laurel@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "DAVAO - BUHANGIN",
    municipality: "DAVAO",
    address:
      "G/F, D3G Bldg., Km. 5 Buhangin Road cor. Gladiola St., Buhangin, Davao City",
    store_email: "#RBG-Division23-Davao-Buhangin@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "DAVAO - AGDAO",
    municipality: "DAVAO",
    address: "Door 2&3 Cabaguio Plaza, Cabaguio Ave., Agdao, Davao City",
    store_email: "#RBG-Division23Davao-Agdao@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "DAVAO - MAC ARTHUR MATINA",
    municipality: "DAVAO",
    address:
      "BGP Commercial Complex II Bldg., McArthur Highway, Matina, Davao Ctiy",
    store_email: "#RBG-Division23-Davao-McArthurMatina@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "DAVAO - QUIRINO",
    municipality: "DAVAO",
    address:
      "Centron Building, Quirino Avenue corner General Luna Street, Davao City",
    store_email: "#RBG-Division23-Davao-Quirino@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "DAVAO - MAGSAYSAY",
    municipality: "DAVAO",
    address:
      "EWB Bldg. Lot 100-C Brgy. 030 Poblacion, R. Magsaysay Ave., Davao City",
    store_email: "#RBG-Division23-Davao-Magsaysay@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "DAVAO - DIVERSION ROAD",
    municipality: "DAVAO",
    address:
      "Unit 4&5, G/F D3G Y10 Bldg.,C.P. Garcia National Highway, Brgy. Cabantian Davao City",
    store_email: "#RBG-Division23-Davao-DiversionRoad@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "DAVAO - MA-A",
    municipality: "DAVAO",
    address:
      "G/F, Rosario Bldg., Don Julian Rodriguez Avenue, Ma-a Road Davao City",
    store_email: "#RBG-Division25-Davao-Ma-a@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "DAVAO - TAGUM",
    municipality: "DAVAO",
    address:
      "Gaisano Grand ArcadeE, Apokon Road cor. Lapu-Lapu Ext., Brgy. Visayan Village, Tagum City",
    store_email: "#RBG-Division28-TagumCity@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "DAVAO - PANABO CITY",
    municipality: "DAVAO",
    address: "Quezon Street, Sto. Niño, Panabo City, Davao del Norte",
    store_email: "#RBG-Division28-Davao-PanaboCity@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "DAVAO - DIGOS",
    municipality: "DAVAO",
    address:
      "Commercial Space-4, Davao RJ and Sons Realty & Trading Corporation Building, V. Sotto Street, Brgy. Zone-1, Digos City, Davao del Sur",
    store_email: "#RBG-Division28-Davao-Digos@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "COTABATO CITY",
    municipality: "COTABATO CITY",
    address: "No. 31 Quezon Avenue, Poblacion 5, Cotabato City",
    store_email: "#RBG-Division28-CotabatoCity@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "GENERAL SANTOS CITY - SANTIAGO",
    municipality: "GEN. SANTOS",
    address: "Ireneo Santiago Boulevard, General Santos City",
    store_email: "#RBG-Division28-GeneralSantos-Santiago@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "KORONADAL CITY",
    municipality: "SOUTH COTABATO",
    address:
      "G/F, RCA Building, Gen. Santos Drive, Koronadal City, South Cotabato",
    store_email: "#RBG-Division28-KoronadalCity@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "GENERAL SANTOS CITY - PIONEER",
    municipality: "GEN. SANTOS",
    address: "Pioneer Avenue corner Magsaysay Avenue, General Santos City",
    store_email: "#RBG-Division28-GeneralSantos-Pioneer@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "KIDAPAWAN",
    municipality: "NORTH COTABATO",
    address:
      "Doña Leonila Complex, National Highway, Poblacion, Kidapawan City,North Cotabato",
    store_email: "#RBG-Division28-Kidapawan@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "GENERAL SANTOS CITY - CALUMPANG",
    municipality: "GEN. SANTOS",
    address:
      "Calumpang Medical Specialist Building, National Highway, Calumpang, General Santos City",
    store_email:
      "#RBG-Division28-GeneralSantosCity-Calumpang@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "TACURONG",
    municipality: "SULTAN KUDARAT",
    address:
      "Tacurong City-Lambayong, National Highway, Tacurong, Sultan Kudarat",
    store_email: "#RBG-Division28-Tacurong@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "SURIGAO CITY",
    municipality: "SURIGAO CITY",
    address: "G/F, EGC Building, Rizal Street, Washington, Surigao City ",
    store_email: "#RBG-Division26-SurigaoCity@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "BUTUAN - P. BURGOS",
    municipality: "BUTUAN CITY",
    address:
      "Units 1, 2, and 3 g/f FSUU Building, P. Burgos corner San Francisco Streets, Brgy. Sikatuna, Butuan City",
    store_email: "#RBG-Division26-Butuan-P.Burgos@eastwestbanker.com",
  },
  {
    location: "Mindanao",
    store_name: "BUTUAN CITY - J. ROSALES",
    municipality: "BUTUAN CITY",
    address:
      "G/F, Deofevente Bldg., Lot No. 7, Governor J. Rosales Ave., Brgy. Imadejas, Butuan City",
    store_email: "#RBG-Division26-ButuanCity@eastwestbanker.com",
  },
  {
    location: "North Luzon",
    store_name: "BAGUIO CITY - ABANAO AVE.",
    municipality: "BAGUIO CITY",
    address:
      "One VF Tower, Benjamin Salvosa Drive, Brgy. Rizal Monument, Baguio City",
    store_email: "#RBG-Division20-Baguio-RizalMonument@eastwestbanker.com",
  },
  {
    location: "North Luzon",
    store_name: "BAGUIO CITY - SESSION ROAD",
    municipality: "BAGUIO CITY",
    address: "Unit B 101 Lopez Bldg Baguio Session",
    store_email: "#RBG-Division22-BaguioCity-SessionRd.@eastwestbanker.com",
  },
  {
    location: "North Luzon",
    store_name: "BENGUET - LA TRINIDAD",
    municipality: "BENGUET",
    address: "KM 5, Central Pico, La Trinidad, Benguet",
    store_email: "#RBG-Division22-Benguet-La Trinidad@eastwestbanker.com",
  },
  {
    location: "North Luzon",
    store_name: "BAGUIO - LEGARDA",
    municipality: "BAGUIO CITY",
    address: "GF Lindi Hotel, #12 Legarda Road, Baguio City",
    store_email: "#RBG-Division22-Baguio-Legarda@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "BACOLOD MANDALAGAN",
    municipality: "BACOLOD CITY",
    address: "Lopues Mandalagan Corp. Bldg., Brgy. Mandalagan, Bacolod City",
    store_email: "#RBG-Division24-Bacolod-Mandalagan@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "BACOLOD HILADO",
    municipality: "BACOLOD CITY",
    address: "Hilado Street, Bacolod City",
    store_email: "#RBG-Division21-Bacolod-Hilado@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "BACOLOD - ARANETA",
    municipality: "BACOLOD CITY",
    address:
      "Unit 1A & 1B Metrodome Building, Araneta - Alunan St. Sincang, Barangay 39, Bacolod City",
    store_email: "#RBG-Division24-Bacolod-Araneta@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "SILAY",
    municipality: "SILAY CITY",
    address: "Rizal Street, Silay City, Negros Occidental ",
    store_email: "#RBG-Division24-Silay@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "BACOLOD - EAST",
    municipality: "BACOLOD CITY",
    address:
      "East Two Corporate Center Building, Circumferential Road, Brgy. Villamonte, Bacolod City",
    store_email: "#RBG-Division24-Bacolod-East@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "BACOLOD-LACSON",
    municipality: "BACOLOD CITY",
    address: "Lacson corner Luzuriaga Sts., Bacolod City",
    store_email: "#RBG-Division24-Bacolod@eastwestbanker.com",
  },
  {
    location: "Visayas",
    store_name: "DUMAGUETE",
    municipality: "DUMAGUETE CITY",
    address: "Don Joaquin T. Villegas Bldg., Colon St., Dumaguete City",
    store_email: "#RBG-Division27-DumagueteCity@eastwestbanker.com",
  },
];

export const getAllMunicipalities = () => {
  let distinctMunicipalities = [];
  store_locations.map((item) => {
    if (!distinctMunicipalities.includes(item.municipality)) {
      distinctMunicipalities.push(item.municipality);
    }
  });
  return distinctMunicipalities;
};

export const getMunicipalitiesByLocation = (loc) => {
  const filteredStores = store_locations.filter(
    (item) => item.location === loc
  );

  let distinctMunicipalities = [];

  filteredStores.map((item) => {
    if (!distinctMunicipalities.includes(item.municipality)) {
      distinctMunicipalities.push(item.municipality);
    }
  });
  return distinctMunicipalities;
};

export const getStoresByMunicipality = (municipality) => {
  return store_locations.filter((item) => item.municipality === municipality);
};

export const getAllLocations = () => {
  let distinctLocations = [];
  store_locations.map((item) => {
    if (!distinctLocations.includes(item.location)) {
      distinctLocations.push(item.location);
    }
  });

  return distinctLocations;
};

export const getStoresByLocation = (storeLocation) => {
  return store_locations.filter((item) => item.location === storeLocation);
};

export const getAllStores = () => {
  return store_locations;
};

export const getLocationByMunicipality = (municipality) => {
  const filteredStores = store_locations.filter(
    (item) => item.municipality === municipality
  );

  let distinctLocations = [];

  filteredStores.map((item) => {
    if (!distinctLocations.includes(item.location)) {
      distinctLocations.push(item.location);
    }
  });
  return distinctLocations;
};

export const getStoreEmails = (store_name) => {
  const store = store_locations.filter((a) => a.store_name === store_name);
  console.log("Store name", store);
  if (store.length > 0) {
    const store_emails = {
      to: store[0].store_email,
      cc: "",
    };
    return store_emails;
  }
  return {
    to: "",
    cc: "",
  };
};

export const locations = [
  ...new Set(store_locations.map((store) => store.location)),
].sort();

export const listStores = [...new Set(store_locations.map((store) => store))];
